import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useParams, useNavigate, json } from "react-router-dom";
// ... other imports
import "./styles/style.css";
// import Config from './Config';
import Svg from "../../../common/Svg";
import { Link } from "react-router-dom";
import { FieldLabel, DropZone } from "@measured/puck";
import ReactEcharts from "echarts-for-react";
import Range from "./Range";
import { Render } from "@measured/puck";
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import logo_fallback from "../../../assets/images/logo-fallback.svg";

const ROIPage = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const frntUrl = process.env.REACT_APP_FRONT_LINK;
  const { roiId } = useParams();
  const [isIdPresent, setIsIdPresent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [renderData, setRenderData] = useState(null);
  const [renderModalData, setRenderModalData] = useState(null);
  const [roiPageData, setRoiPageData] = useState(null);
  const [condtionValues, setCondtionValues] = useState([]);
  const [actionId, setActionId] = useState([]);
  //all condtions and actions data
  // const [allCondtionalLogicData, setAllConditionalLogicData] = useState([]);
  const allCondtionalLogicData = useRef([]);
  const [allActionData, setAllActionData] = useState([]);
  // const [currentPageId, setCurrentPageId] = useState(null);
  const currentPageId = useRef(null);
  const [currentPopupPageId, setCurrentPopupPageId] = useState("");
  const [popupStatus, setPopupStatus] = useState(false);
  // const [roipages, setRoipages] = useState({});
  const roipages = useRef({});
  const [roiVariableData, setRoiVaiableData] = useState({});
  // const [roiActionArr, setRoiActionArr] = useState({});
  const roiActionArr_global = useRef({});
  const [roiFlag, setRoiFlag] = useState(false);
  const [language, setLanguage] = useState("");
  const [currency, setCurrency] = useState([]);
  const [defaultCurrency, setDefaultCurrency] = useState("");
  const [changedCurrency, setChangedCurrency] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [locale, setLocale] = useState("");
  // const [globalRoiArr, setGlobalRoiArr] = useState([]);
  const globalRoiArr = useRef([]);
  const elements_by_page_id = useRef({});
  const [changedDropdown, setChangedDropdown] = useState({});
  const [isLoadingdownload, setIsLoadingdownload] = useState(false);
  const [handleModal, setHandleModal] = useState(false);
  const [acceptDecimals, setAcceptDecimals] = useState(false);

  const LEGACY_VALIDATION_DEFAULTS = {
    requiredField: "Please enter a valid value",
    checkbox:
      "To continue, you must agree to the terms and privacy policy.",
    radio: "Please select at least one option",
  };
  const validationDefaultMessages = useRef({ ...LEGACY_VALIDATION_DEFAULTS });

  const DEFAULT_LOGO_PROMPT_MODAL_TEXT = {
    heading: "Return to home page?",
    subheading: "You will have to complete the steps again.",
    closeButtonText: "Close",
    confirmButtonText: "Confirm",
  };
  const [logoPromptModalText, setLogoPromptModalText] = useState(
    DEFAULT_LOGO_PROMPT_MODAL_TEXT
  );

  const getScopedRoiKey = (pageId, uuid) => `${pageId}::${uuid}`;

  const SHARED_UUID_STATE_FIELDS = [
    "value",
    "hide",
    "errorMessage",
    "default_value",
    "count",
  ];

  const pickSharedUuidState = (entry = {}) => {
    const shared = {};
    SHARED_UUID_STATE_FIELDS.forEach((field) => {
      if (entry[field] !== undefined) {
        shared[field] = entry[field];
      }
    });
    return shared;
  };

  const getScopedKeysForUuid = (store, uuid) =>
    Object.keys(store || {}).filter((key) => key.endsWith(`::${uuid}`));

  const mergeEntryWithSharedFlat = (store, uuid, entry) => {
    if (!entry) return entry;
    const flat = store?.[uuid];
    if (!flat) return entry;
    return {
      ...entry,
      ...pickSharedUuidState(flat),
      required: flat.required ?? entry.required,
      customErrorMessage: flat.customErrorMessage ?? entry.customErrorMessage,
      type: flat.type ?? entry.type,
      validationError: flat.validationError ?? entry.validationError,
      checkbox_id: flat.checkbox_id ?? entry.checkbox_id,
    };
  };

  const syncSharedUuidState = (store, uuid, patch) => {
    if (!uuid || !store) return store;

    const sharedPatch = pickSharedUuidState(patch);
    if (Object.keys(sharedPatch).length === 0) {
      return store;
    }

    const next = { ...store };
    const scopedKeys = getScopedKeysForUuid(next, uuid);
    const baseEntry =
      next[uuid] ||
      (scopedKeys.length > 0 ? { ...next[scopedKeys[0]] } : {});

    const mergedFlat = { ...baseEntry, ...sharedPatch };
    next[uuid] = mergedFlat;

    scopedKeys.forEach((scopedKey) => {
      next[scopedKey] = { ...next[scopedKey], ...sharedPatch };
    });

    return next;
  };

  const applySharedUuidState = (uuid, patch) => {
    roiActionArr_global.current = syncSharedUuidState(
      roiActionArr_global.current,
      uuid,
      patch
    );
  };

  const resolveRoiVariableEntry = (
    store,
    uuid,
    preferredPageId = currentPageId.current
  ) => {
    if (!uuid || !store) {
      return { storageKey: null, entry: null };
    }
    if (store[uuid]) {
      let entry = store[uuid];
      if (preferredPageId) {
        const scopedKey = getScopedRoiKey(preferredPageId, uuid);
        const scopedEntry = store[scopedKey];
        if (scopedEntry) {
          entry = {
            ...scopedEntry,
            ...pickSharedUuidState(store[uuid]),
            required: store[uuid].required ?? scopedEntry.required,
            customErrorMessage:
              store[uuid].customErrorMessage ?? scopedEntry.customErrorMessage,
            type: store[uuid].type ?? scopedEntry.type,
            validationError:
              store[uuid].validationError ?? scopedEntry.validationError,
            checkbox_id: store[uuid].checkbox_id ?? scopedEntry.checkbox_id,
          };
        }
      }
      return { storageKey: uuid, entry };
    }
    if (preferredPageId) {
      const preferredScoped = getScopedRoiKey(preferredPageId, uuid);
      if (store[preferredScoped]) {
        return {
          storageKey: preferredScoped,
          entry: mergeEntryWithSharedFlat(store, uuid, store[preferredScoped]),
        };
      }
    }
    const scopedKey = Object.keys(store).find((key) => key.endsWith(`::${uuid}`));
    if (scopedKey) {
      return {
        storageKey: scopedKey,
        entry: mergeEntryWithSharedFlat(store, uuid, store[scopedKey]),
      };
    }
    return { storageKey: null, entry: null };
  };

  const isTruthyRequired = (value) =>
    value === true || value === "true" || value === 1 || value === "1";

  const isRoiFieldRequired = (entry, props) =>
    isTruthyRequired(entry?.required) || isTruthyRequired(props?.required);

  const shouldValidateEmptyField = (entry, props) =>
    isRoiFieldRequired(entry, props) ||
    Boolean(
      entry?.customErrorMessage ||
      props?.customErrorMessage ||
      props?.errorMessage
    );

  const isRadioFieldEmpty = (entry, props) => {
    const value = entry?.value ?? props?.value;
    return (
      value == 0 ||
      value === "0" ||
      String(value ?? "").trim() === ""
    );
  };

  const FIELDS_WITH_CONFIGURED_ERRORS = new Set([
    "Checkbox",
    "InputTextField",
    "InputNumberField",
    "Radio",
  ]);

  const isInputFieldEmpty = (entry, componentType = "") => {
    const value = entry?.value;
    if (componentType === "InputNumberField") {
      return (
        value === "" ||
        value === undefined ||
        value === null ||
        String(value).trim() === ""
      );
    }
    return String(value ?? "").trim() === "";
  };

  const getConfiguredFieldErrorMessage = (entry, props, fallback) =>
    entry?.customErrorMessage ||
    props?.customErrorMessage ||
    props?.errorMessage ||
    fallback;

  const PAGE_INPUT_FIELD_TYPES = new Set([
    "InputTextField",
    "InputNumberField",
    "Textarea",
    "Dropdown",
  ]);

  const collectPageInputFields = (pageId) => {
    const structure = parsePageStructure(roipages.current[pageId]);
    if (!structure) return [];

    const fields = [];
    const walk = (node) => {
      if (!node || typeof node !== "object") return;
      if (Array.isArray(node)) {
        node.forEach(walk);
        return;
      }

      if (PAGE_INPUT_FIELD_TYPES.has(node.type) && node.props?.uuid) {
        fields.push({
          uuid: node.props.uuid,
          componentType: node.type,
          props: node.props,
        });
      }

      Object.values(node).forEach(walk);
    };

    walk(structure.content);
    walk(structure.zones);
    return fields;
  };

  const collectPageRadioFields = (pageId) => {
    const structure = parsePageStructure(roipages.current[pageId]);
    if (!structure) return [];

    const fields = [];
    const walk = (node) => {
      if (!node || typeof node !== "object") return;
      if (Array.isArray(node)) {
        node.forEach(walk);
        return;
      }

      if (node.type === "Radio" && node.props?.uuid) {
        fields.push({
          uuid: node.props.uuid,
          props: node.props,
        });
      }

      Object.values(node).forEach(walk);
    };

    walk(structure.content);
    walk(structure.zones);
    return fields;
  };

  const syncFormValuesToGlobalState = () => {
    const formValues = getFormValuesById(document.body);
    Object.keys(formValues).forEach((elementId) => {
      if (
        elementId &&
        formValues[elementId] !== undefined &&
        formValues[elementId] !== null
      ) {
        applySharedUuidState(elementId, { value: formValues[elementId] });
      }
    });
    return formValues;
  };

  const setFieldValidationState = (
    uuid,
    { errorMessage = "", validationError = false } = {}
  ) => {
    if (!uuid) return;
    applySharedUuidState(uuid, { errorMessage });
    const { entry } = resolveRoiVariableEntry(
      roiActionArr_global.current,
      uuid,
      currentPageId.current
    );
    roiActionArr_global.current = {
      ...roiActionArr_global.current,
      [uuid]: {
        ...(roiActionArr_global.current[uuid] || entry || {}),
        errorMessage,
        validationError,
      },
    };
  };

  const clearFieldValidationState = (uuid) => {
    setFieldValidationState(uuid, { errorMessage: "", validationError: false });
  };

  const patchRoiVariableEntry = (store, uuid, preferredPageId, patch) =>
    syncSharedUuidState(store, uuid, patch);

  // Focus management for tab index
  const [focusedInputId, setFocusedInputId] = useState(null);
  const [pendingChanges, setPendingChanges] = useState({});
  const [isProcessingChanges, setIsProcessingChanges] = useState(false);

  const CurrencyFormatter = ({ amount }) => {
    const formattedAmount = amount.toLocaleString(locale, {
      style: "currency",
      currency: changedCurrency == "" ? defaultCurrency : changedCurrency,
    });
    return formattedAmount;
  };

  /*****Year and VBUC******/
  const [selectedCompany, setSelectedCompany] = useState("vbuc");
  const [selectedYear, setSelectedYear] = useState("year1");

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // const getDataSection = () => {
  //     if (selectedCompany === 'vbuc' && selectedYear === 'year1') {
  //         return <ReactEcharts style={chartStyle} option={pieChart()} />;
  //     }
  //     if (selectedCompany === 'vbuc' && selectedYear === 'year3') {
  //         return <ReactEcharts style={chartStyle} option={VBUCYear3Options} />;
  //     }
  //     if (selectedCompany === 'microsoft' && selectedYear === 'year1') {
  //         return <ReactEcharts style={chartStyle} option={MicrosoftYear1Options} />;
  //     }
  //     if (selectedCompany === 'microsoft' && selectedYear === 'year3') {
  //         return <ReactEcharts style={chartStyle} option={MicrosoftYear3Options} />;
  //     }
  // };

  const pieChart = (items) => {

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: parseFloat(item.value), // Convert value to a number if it's a string
      name: item.Text,
      symbol: currencySymbol,
      formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
    }));

    // Extract colors from items
    const colors = items.map((item) => item.Color);

    return {
      tooltip: {
        trigger: "item",

        formatter: function (params) {
          return `${params.seriesName}<br />
                        ${params.data.name}:  ${params.data.formatted} `;
        },
      },
      grid: {
        left: "30%",
        right: "4%",
        bottom: "10%",
        containLabel: true,
      },
      series: [
        {
          name: "Cost savings over yearly vs average",
          type: "pie",
          radius: "80%",
          color: colors, // Use the extracted colors
          data: seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  };

  const getChartItemValue = (item) => {
    const raw = item?.value ?? item?.Data ?? 0;
    const parsed = parseFloat(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const pieEChart = (items, title, subtext) => {
    // Special styling for roiId c51d1af0-0099-11ef-8e49-4bdeaebfbca1
    const isSpecialRoi = roiId === 'c51d1af0-0099-11ef-8e49-4bdeaebfbca1';

    let totalValue = 0;
    for (let i = 0; i < items.length; i++) {
      totalValue += getChartItemValue(items[i]);
    }

    // Format the total value for display
    const formattedTotal = totalValue >= 1000000 
      ? (totalValue / 1000000).toFixed(2) + 'M'
      : totalValue >= 1000 
        ? (totalValue / 1000).toFixed(1) + 'K'
        : totalValue.toFixed(2);

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: getChartItemValue(item),
      name: item.Text,
      symbol: currencySymbol,
      formatted: CurrencyFormatter({ amount: getChartItemValue(item) }),
    }));

    // Extract colors from items
    const colors = items.map((item) => item.Color);
    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
      },
      legend: {
        orient: "horizontal",
        left: "center",
        bottom: isSpecialRoi ? "5%" : "0", // Adjust as needed for vertical position
        data: legend, // Matches the names in series.data
        itemGap: isSpecialRoi ? 15 : 20, // Reduced space between legend items
        itemWidth: 12,
        itemHeight: 12,
        textStyle: {
          fontSize: isSpecialRoi ? 10 : 11,
        },
      },
      // title is used for the text in the center of the donut
      title: {
        text: title, // The label text (e.g., "First Year")
        subtext: formattedTotal, // Formatted total value
        left: "center",
        top: isSpecialRoi ? "38%" : "35%", // Adjusted position

        textStyle: {
          fontSize: isSpecialRoi ? 11 : 12, // Smaller font for title
          fontWeight: "normal",
          color: "#666",
        },
        subtextStyle: {
          fontSize: isSpecialRoi ? 14 : 18, // Reduced font size for the value
          fontWeight: "bold",
          color: "#333",
        },
      },
      series: [
        {
          type: "pie",
          // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
          radius: isSpecialRoi ? ["30%", "55%"] : ["35%", "65%"], // Adjusted for better spacing
          center: isSpecialRoi ? ["50%", "42%"] : ["50%", "45%"], // Moved up slightly to make room for legend
          avoidLabelOverlap: true, // Avoid label overlap
          color: colors,
          data: seriesData,
          label: {
            show: true,
            position: "outside",
            formatter: function(params) {
              // Format large numbers
              const val = params.value;
              if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M';
              if (val >= 1000) return (val / 1000).toFixed(0) + 'K';
              return val.toFixed(0);
            },
            color: "#333",
            fontSize: isSpecialRoi ? 9 : 10,
            distanceToLabelLine: isSpecialRoi ? 1 : 2,
          },
          labelLine: {
            show: true,
            length: isSpecialRoi ? 5 : 8, // Shorter line
            length2: isSpecialRoi ? 3 : 5,
            smooth: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.3)",
            },
            label: {
              show: true,
              fontSize: "12",
              fontWeight: "bold",
            },
          },
        },
      ],
      grid: {
        left: "5%",
        right: "5%",
        bottom: isSpecialRoi ? "25%" : "20%", // More space for legend
        top: "5%",
        containLabel: true,
      },
    };
  };


  const barEChart = (items, title, subtext) => {
    // Prepare series
    const series = items.map((item) => ({
      name: item.Text,
      type: "bar",
      barWidth: 40, // Match BarChartOptions
      data: [getChartItemValue(item)], // Single value per series
      itemStyle: {
        color: item.Color,
        borderRadius: [5, 5, 0, 0], // Match BarChartOptions
      },
      emphasis: { focus: "series" },
      label: {
        show: true,
        position: "top",
        formatter: "{c}",
        color: "#333",
        fontSize: 12,
      },
    }));

    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        // Optionally, use the same formatter as BarChartOptions
      },
      legend: {
        show: true,
        data: legend,
        bottom: "0",
        left: "center",
        itemGap: 15,
        itemWidth: 12,
        itemHeight: 12,
        icon: "circle",
        textStyle: {
          color: "#595959",
          fontSize: 13,
        },
      },
      grid: {
        left: "3%",
        top: "10%",
        right: "4%",
        bottom: "35%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: [""], // Single group
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
        },
      ],
      yAxis: [
        {
          type: "value",
          min: 0,
          // Optionally set max and interval as in BarChartOptions
          axisLabel: {
            color: "#595959",
            fontSize: 14,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#E0E0E0",
            },
          },
        },
      ],
      series,
    };
  };

  // For Download Report

  const OneYearChartOptions = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    grid: {
      left: "30%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: [
      {
        name: "Actual Benefits with Vodafone",
        type: "pie",
        radius: "50%",
        color: ["#9C2AA0", "#EB9700", "#00B0CA"], // Specify colors for the pie slices here
        data: [
          { value: 1048, name: "Lower Costs" },
          { value: 735, name: "Increase Productivity" },
          { value: 580, name: "Enable Business" },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  const ThreeYearChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    grid: {
      left: "0%",
      top: "30%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: ["2022", "2023", "2024"],
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: [
      {
        name: "Lower Costs",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#9C2AA0", // Apply purple color here
        },
        data: [120, 132, 101, 134, 90, 230, 210],
      },
      {
        name: "Increase Productivity",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#EB9700", // Apply orange color here
        },
        data: [220, 182, 191, 234, 290, 330, 310],
      },
      {
        name: "Enable Business",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#00B0CA", // Apply cyan color here
        },
        data: [150, 232, 201, 154, 190, 330, 410],
      },
    ],
  };

  const chartStyle = {
    height: "200px",
    width: "100%",
  };

  const PieChartOptions = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
    },
    legend: {
      orient: "horizontal",
      left: "center",
      bottom: "0", // Adjust as needed for vertical position
      data: ["Basic", "Standard", "Premium"], // Matches the names in series.data
      itemGap: 50, // Space between legend items
      itemWidth: 15, // <--- ADD THIS: Width of the colored box (e.g., 15 pixels)
      itemHeight: 15, // <--- ADD THIS: Height of the colored box (e.g., 15 pixels)
    },
    // title is used for the text in the center of the donut
    title: {
      text: "Total Licence", // The main number
      subtext: "450", // The text below the number
      left: "center",
      top: "42%", // Position in the middle of the chart

      textStyle: {
        fontSize: 14, // Adjust font size for "Total Licenses"
        fontWeight: "normal",
        color: "#666", // Adjust color as needed
      },
      subtextStyle: {
        fontSize: 36, // Adjust font size for "450"
        fontWeight: "bold",
        color: "#333", // Adjust color as needed
      },
    },
    series: [
      {
        name: "Licence", // A name for the series, appears in tooltips
        type: "pie",
        // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
        // Adjust these percentages for the desired thickness of the donut
        radius: ["40%", "75%"],
        center: ["50%", "50%"], // Ensure chart is centered if title is also centered
        avoidLabelOverlap: false, // Important for custom label positioning
        color: ["#9C2AA0", "#EB9700", "#00B0CA"], // Purple, Orange, Teal
        data: [
          { value: 250, name: "Premium" }, // Corresponds to #9C2AA0 (Purple)
          { value: 100, name: "Standard" }, // Corresponds to #EB9700 (Orange)
          { value: 100, name: "Basic" }, // Corresponds to #00B0CA (Teal)
        ],
        label: {
          show: true,
          position: "outside",
          formatter: "{c}", // Show the value (count) on the label
          color: "#333", // Label text color
          fontSize: 12,
          // distanceToLabelLine: 5, // Optional: adjust space between label and line start
        },
        labelLine: {
          show: true,
          length: 15, // Length of the first part of the line
          length2: 10, // Length of the second part of the line (after the jog)
          smooth: false, // Use straight lines
        },
        emphasis: {
          // Style when hovering over a slice
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.3)",
          },
          label: {
            // Optional: make label more prominent on hover
            show: true,
            fontSize: "14",
            fontWeight: "bold",
          },
        },
        // The `top` property from your original series is removed as `center` and `title` positioning handles it.
      },
    ],
    // The `grid` option is generally not needed for pie charts, but keeping it won't harm.
    // You can remove it if you prefer.
    grid: {
      left: "5%", // Adjusted to give more space if labels are long
      right: "5%",
      bottom: "15%", // Ensure space for the legend
      containLabel: true,
    },
  };

  const BarChartOptions = {
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      // The default tooltip formatter for 'axis' trigger will list all series.
    },
    legend: {
      show: true,
      data: [
        "Remote Workers",
        "Office Workers",
        "On the Road Workers",
        "Hybrid Workers",
      ], // Derived from series names
      bottom: "0", // Or '5%' or adjust as needed
      left: "center",
      itemGap: 15,
      itemWidth: 12,
      itemHeight: 12,
      icon: "circle", // Make all legend icons circles
      textStyle: {
        color: "#595959", // Matching image text color
        fontSize: 13,
      },
    },
    grid: {
      left: "3%", // Adjust if y-axis labels need more or less space
      top: "5%", // Space from the top
      right: "4%", // Space from the right
      bottom: "35%", // Ample space for the legend below the x-axis area
      containLabel: true, // Ensures labels (like y-axis) fit
    },
    xAxis: [
      {
        type: "category",
        // Using an empty string or a non-displaying character for a single grouping point
        // if you don't want any visible x-axis label below the bars.
        // Or, if each bar IS a category, then it should be:
        // data: ['Remote Workers', 'Office Workers', 'On the Road Workers', 'Hybrid Workers'],
        // However, to match the *visual* of a single group of 4 bars,
        // and have the legend define what each bar is:
        data: [""], // A single, empty category to group the bars
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { show: false }, // No visible x-axis labels
      },
    ],
    yAxis: [
      {
        type: "value",
        min: 0,
        max: 100,
        interval: 25,
        axisLabel: {
          margin: 10,
          color: "#595959", // Matching image text color
          fontSize: 14,
        },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#E0E0E0", // Lighter dashed lines
          },
        },
      },
    ],
    series: [
      {
        name: "Remote Workers",
        type: "bar",
        barWidth: 40, // Fixed width for each bar
        // barGap: '30%', // Optional: space between bars of different series (within same category)
        itemStyle: {
          color: "#A5B83C", // Olive Green
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [68], // Value for the single x-axis category ''
      },
      {
        name: "Office Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#00B0CA", // Teal
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [88],
      },
      {
        name: "On the Road Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#9C2AA0", // Purple
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [43],
      },
      {
        name: "Hybrid Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#EB9700", // Orange
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [76],
      },
    ],
  };
  // Create Puck component config
  const config = {
    categories: {
      Banner: {
        components: ["BannerLeftTextRightImage", "BannerCenterText"],
      },

      Cards: {
        components: ["CardLayout1", "CardLayout2"],
      },
    },

    components: {
      //Header Components
      PageHeader: {
        render: ({
          logo,
          items,
          hide,
          showCurrencyDropdown,
          showRecalculateButton,
          showLanguageDropdown,
          transparentHeader,
          recalculateButtonText,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;



          return (
            <div
              className={`roi-header-main ${transparentHeader && "header-transparent"
                }`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  {/* <a href="" className="logo">
                                        <img src={logo} alt="" onClick={homeRedirect} />
                                    </a> */}
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={logo} alt="" />
                    ) : (
                      <img src={logo_fallback} alt="" />
                    )}
                  </a>
                  <div className="nav-menu">
                    <ul>
                      {items?.map((item, i) => (
                        <li
                          key={i}
                          onClick={() => {
                            const targetId = item.buttonValue || item.PageList || "";
                            if (
                              targetId &&
                              normalizePageStructureString(roipages.current[targetId])
                            ) {
                              jumpToPage(targetId);
                            } else {
                              console.error("[JumpToPage] Header nav target not found", {
                                targetId,
                                currentPageId: currentPageId.current,
                                availablePageIds: Object.keys(roipages.current),
                              });
                            }
                          }}
                        >
                          <Link
                            to=""
                            className={item.activeStatus == 1 ? "active" : ""}
                          >
                            {item.Text}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="space">
                    {showCurrencyDropdown || showLanguageDropdown || showRecalculateButton ? (
                      <div className="d-flex currency-language">
                        {showRecalculateButton && <>
                          <button className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3"
                            //onClick={handleRecalculateClick}
                            data-bs-toggle="modal"
                            data-bs-target="#logoPrompt">

                            <Svg name="roi-recalculate-icon" /> {recalculateButtonText || "Start Over"}

                          </button>
                        </>}
                        {showLanguageDropdown && (
                          <div className="lang-wrap">
                            <Svg name="language-globe" />
                            <select className="language">
                              <option value="1">English</option>
                              <option value="2">Spanish</option>
                            </select>
                          </div>
                        )}
                        {showCurrencyDropdown && (
                          <select
                            className="currency"
                            onChange={(e) => currencyChange(e)}
                          >
                            <option
                              value={defaultCurrency}
                              selected={
                                changedCurrency == "" ||
                                  changedCurrency == defaultCurrency
                                  ? "selected"
                                  : ""
                              }
                            >
                              {defaultCurrency}
                            </option>
                            {currency.map((item, i) => (
                              <option
                                value={item}
                                selected={
                                  changedCurrency == item ? "selected" : ""
                                }
                                key={i}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      PageHeaderTransparent: {
        render: ({ logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <div
              className="roi-header-transparent"
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a className="logo">
                    <img src={logo} alt="" />
                  </a>
                </div>
              </div>
            </div>
          );
        },
      },

      // Banner Layouts
      BannerLeftTextRightImage: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          Style,
          image,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative ${Padding.bottom
                  } ${Padding.top} ${Style} ${Padding.fullHeight && "full-height"
                  }`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="row align-items-center ">
                    <div className="col-lg-6">
                      <div className="banner-text">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              onClick={() => onButtonClick(Button.uuid, null, Button)}
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              onClick={() => onButtonClick(Button.uuid, null, Button)}
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="img-wrapper">
                        <img src={image} className="img-fluid" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      BannerCenterText: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          image,
          Style,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${image}")`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  opacity: inputOpacity,
                }}
              >
                <div className="overlay"></div>
                <div className="container position-relative">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-lg-8">
                      <div className="banner-text text-center">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Cards Layouts
      CardLayout1: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          Card4,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="card-nav-outer">
                  <div className="container">
                    <div className="card-nav d-flex align-items-center justify-content-between">
                      {/* <div className="card-prev text-start">
                                                <button className='prev-btn card-btn'>Back</button>
                                            </div> */}

                      <div className="card-next text-end">
                        {/**Only Hide button in case not to be shown**/}
                        {/* <button className='next-btn card-btn'>Next</button> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>

                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card1.uuid)}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card2.uuid)}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Card3 != undefined && Card3 != null && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card3.uuid)}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4>{Card3.title}</h4>
                                <p>{Card3.text}</p>
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {Card4 != undefined && Card4 != null && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card4.uuid)}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4>{Card4.title}</h4>
                                <p>{Card4.text}</p>
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardLayout2: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>
                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card3.title}</h4>
                              <p>{Card3.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Layouts
      SinglePage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone="nav-wrapper" allow={["FormNav"]} />
                  <div className="form-wrapper">
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.descriptionFont}>
                        {Description.text}
                      </p>
                    </div>
                    <div className="form-inner">
                      <DropZone
                        zone="form-wrapper"
                        disallow={["SinglePage", "WizardForm"]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      FormNav: {
        render: ({ items, hide }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <ul className="nav nav-tabs nav-tabs-single">
                {items.map((item, i) => (
                  <li className="nav-item" role="presentation" key={i}>
                    {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                    <button
                      onClick={() => onButtonClick(item.uuid)}
                      className={
                        item.isActive == true ? "nav-link active" : "nav-link"
                      }
                    >
                      {item.Title}
                    </button>
                  </li>
                ))}
              </ul>
            </>
          );
        },
      },
      FormNav2: {

        render: ({ items, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          // Calculate progress percentage
          const totalSteps = items.length;
          const completedSteps = items.filter(item => item.isDone).length;
          const progressPercentage = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;

          return (
            <>
              {/* Wizard Progress Steps */}
              <div className="wizard-progress" style={{ opacity: inputOpacity }}>
                <div className="wizard-steps">
                  {items.map((item, i) => (
                    <div key={i} className={`wizard-step ${item.isDone ? 'completed' : ''} ${item.isActive ? 'active' : ''}`}>
                      <div className="step-circle">
                        {item.isDone ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} viewBox="0 0 16 12" fill="none">
                            <path d="M1.37207 4.63043L6.18052 9.43888L14.532 1.08736" stroke="white" strokeWidth={3} />
                          </svg>

                        ) : (
                          <span>{i + 1}</span>
                        )}
                      </div>
                      <div className="step-label">{item.Title}</div>
                      {i < items.length - 1 && (
                        <div className={`step-connector ${item.isDone ? 'completed' : ''}`}></div>
                      )}
                    </div>
                  ))}
                </div>


              </div>


            </>
          )
        },
      },


      WizardForm: {
        render: ({ Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {items.map((item, i) => (
                      <li className="nav-item" role="presentation" key={i}>
                        {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                        <button
                          className={i === 0 ? "nav-link active" : "nav-link"}
                          id={`tab-${i}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#tab-${i}-pane`}
                          type="button"
                          role="tab"
                          aria-controls={`tab-${i}-pane`}
                          aria-selected="false"
                        >
                          {item.Title}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div className="form-wrapper">
                    <div className="tab-content" id="myTabContent">
                      {items.map((item, i) => (
                        <div
                          key={i}
                          className={
                            i === 0
                              ? "tab-pane fade show active"
                              : "tab-pane fade"
                          }
                          id={`tab-${i}-pane`}
                          role="tabpanel"
                          aria-labelledby={`tab-${i}`}
                          tabIndex={0}
                        >
                          <div className="section-heading mb-3 mb-md-4">
                            <h2 className={`heading fw-700 fs-40`}>
                              {item.Title}
                            </h2>
                            <p className="fs-22">{item.Description}</p>
                          </div>
                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper-${i}`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Elements

      InputTextField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          validationError,
          hint,
          hintStyle,
          hide,
          Prefix,
          uuid,
          tabIndex,
          Style,
          Font,
          Border,
          Padding,
          Margin,
        }) => {
          // Render nothing if hide is true
          if (hide == true || hide == 'true') {
            return null;
          }

          const showFieldError = validationError && errorMessage;

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label" for={uuid}>
                    <span dangerouslySetInnerHTML={{ __html: label }} /> {required && <span className="required">*</span>}{" "}
                    {hint && (
                      <div className={`hint ${hintStyle}`}>
                        <button type="button" className="info" tabIndex={0}>
                          <Svg name="hint-button" />
                        </button>
                        <div
                          className="popover"
                          dangerouslySetInnerHTML={{ __html: hint }}
                        ></div>
                      </div>
                    )}
                  </label>
                )}
                <div className="position-relative">
                  {(() => {
                    if (Prefix === "currency") {
                      return (
                        <input

                          {...(disableEditing ? { disabled: true } : {})}
                          type={"text"}
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${showFieldError ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                          defaultValue={CurrencyFormatter({
                            amount: parseFloat(value),
                          }).normalize()}
                          id={uuid}
                          tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onFocus={handleInputFocus}
                          onBlur={(e) => handleInputBlur(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                          }}
                        />
                      );
                    } else {
                      return (
                        <input
                          {...(disableEditing ? { disabled: true } : {})}
                          type={"text"}
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${showFieldError ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          defaultValue={value}
                          id={uuid}
                          tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onFocus={handleInputFocus}
                          onBlur={(e) => handleInputBlur(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                            display: `${Style?.Display}`,
                          }}
                        />
                      );
                    }
                  })()}

                  {!showLabel && hint && (
                    <div className={`hint ${hintStyle}`}>
                      <button type="button" className="info" tabIndex={0}>
                        <Svg name="hint-button" />
                      </button>
                      <div
                        className="popover"
                        dangerouslySetInnerHTML={{ __html: hint }}
                      ></div>
                    </div>
                  )}
                </div>

                {showFieldError && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      InputNumberField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          validationError,
          hint,
          hintStyle,
          hide,
          Prefix,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
          tabIndex,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          const showFieldError = validationError && errorMessage;

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    <span dangerouslySetInnerHTML={{ __html: label }} /> {required && <span className="required">*</span>}{" "}
                    {hint && (
                      <div className={`hint ${hintStyle}`}>
                        <button type="button" className="info" tabIndex={0}>
                          <Svg name="hint-button" />
                        </button>
                        <div
                          className="popover"
                          dangerouslySetInnerHTML={{ __html: hint }}
                        ></div>
                      </div>
                    )}
                  </label>
                )}
                <div className="position-relative">
                  {Prefix == "none" && (
                    <input
                      {...(disableEditing ? { disabled: true } : {})}
                      type="number"
                      min="0"
                      className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                        } ${showFieldError ? "error" : ""}`}
                      placeholder={placeholder}
                      defaultValue={value}
                      id={uuid}
                      tabIndex={tabIndex ?? ""}
                      required={required}
                      onFocus={handleInputFocus}
                      onBlur={(e) => handleInputBlur(uuid, e, required)}
                      onWheel={handleWheelPrevention}
                      onMouseWheel={handleWheelPrevention}
                      onKeyDown={preventScrollAndArrowKeys}
                      style={{
                        backgroundColor: `${Style?.BackgroundColor}`,
                        color: `${Style?.Color}`,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                        borderStyle: `${Border?.BorderStyle}`,
                        borderColor: `${Border?.BorderColor}`,
                        borderWidth: `${Border?.BorderWidth}px`,
                        borderRadius: `${Border?.BorderRadius}px`,
                        height: `${Style?.Height}px`,
                        textAlign: Font?.Align,
                        pointerEvents: 'auto',
                      }}
                    />
                  )}

                  {Prefix == "%" && (
                    <div className="input-group percent">
                      <input
                        {...(disableEditing ? { disabled: true } : {})}
                        type="number"
                        min="0"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${showFieldError ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={value}
                        id={uuid}
                        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                        required={required}
                        onFocus={handleInputFocus}
                        onBlur={(e) => handleInputBlur(uuid, e, required)}
                        onWheel={handleWheelPrevention}
                        onMouseWheel={handleWheelPrevention}
                        onKeyDown={preventScrollAndArrowKeys}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                          pointerEvents: 'auto',
                        }}
                      />
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                      >
                        %
                      </span>
                    </div>
                  )}

                  {Prefix == "currency" && (
                    <div className="input-group currency">
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                        dangerouslySetInnerHTML={{ __html: currencySymbol }}
                      ></span>
                      {/**Change this currency depending upon default currency**/}
                      <input
                        {...(disableEditing ? { disabled: true } : {})}
                        type="number"
                        min="0"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${showFieldError ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={value}
                        id={uuid}
                        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                        required={required}
                        onFocus={handleInputFocus}
                        onBlur={(e) => handleInputBlur(uuid, e, required)}
                        onWheel={handleWheelPrevention}
                        onMouseWheel={handleWheelPrevention}
                        onKeyDown={preventScrollAndArrowKeys}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                          pointerEvents: 'auto',
                        }}
                      />
                    </div>
                  )}

                  {!showLabel && hint && (
                    <div className={`hint ${hintStyle}`}>
                      <button type="button" className="info" tabIndex={0}>
                        <Svg name="hint-button" />
                      </button>
                      <div
                        className="popover"
                        dangerouslySetInnerHTML={{ __html: hint }}
                      ></div>
                    </div>
                  )}
                </div>

                {showFieldError && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      TextareaField: {
        render: ({
          label,
          value,
          placeholder,
          required,
          errorMessage,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          showLabel,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <textarea
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  value={value}
                  id={uuid}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Dropdown: {
        render: ({
          label,
          showLabel,
          required,
          errorMessage,
          items,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <select
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize
                    } ${errorMessage ? "error" : ""}`}
                  onChange={(e) => handleDropdownChange(uuid, e)}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    backgroundSize: `${Style?.DropdownSize}px`,
                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                  }}
                  defaultValue={changedDropdown[uuid]}
                >
                  <option value>--Select--</option>
                  {items.map((item, i) => (
                    <option key={i} value={item.Option}>
                      {item.Option}
                    </option>
                  ))}
                </select>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Checkbox: {
        render: ({
          label,
          required,
          errorMessage,
          items,
          ID,
          hide,
          Margin,
          Style,
          validationError,
        }) => {
          if (hide) {
            return null;
          }

          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}

                <div className="roi-check-wrap">
                  {items.map((item, i) => (
                    <div key={i}>
                      <label className="form-check" htmlFor={`${ID}-${i}`} >
                        <input
                          id={`${ID}-${i}`}
                          className="form-check-input"
                          name={ID}
                          type="checkbox"
                          checked={item.value == 1 ? true : false}
                          onChange={() => {
                            onCheckBoxClick(item.uuid);
                          }}
                        />
                        <span className="form-check-label" dangerouslySetInnerHTML={{ __html: item.Option }} />
                      </label>
                    </div>
                  ))}
                </div>
                {validationError && errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      //  Radio component
      Radio: {
        render: ({
          label,
          required,
          errorMessage,
          validationError,
          items,
          ID,
          hide,
          uuid,
          value
        }) => {
          // Added initialValue
          if (hide) {
            return null;
          }
          const inputOpacity = hide ? 0.5 : 1;
          const showFieldError = validationError && errorMessage;



          return (
            <>
              <div
                className="roi-form-group position-relative"
                style={{ opacity: inputOpacity }}
              >

                {label && <label className='field-label'>{label} {required && <span className='required'>*</span>}</label>}

                <div className="roi-check-wrap">
                  {items.map((item, i) => {
                    const radioId = `${ID}-${i}`;



                    return (
                      <label className="form-check" key={i} htmlFor={radioId}>
                        <input
                          className="form-check-input"
                          type="radio"
                          value={item.value} // Use the item's value
                          id={radioId}
                          name={ID}
                          checked={item.value == value}
                          onChange={() => onRadioClick(uuid, item.value)}
                        // Add the change handler here
                        // If you have an initial value, you might want to set defaultChecked
                        // defaultChecked={initialValue === radioValue} // For initial render check
                        />
                        <span className="form-check-label" >
                          {item.RadioOption}
                        </span>
                      </label>
                    );
                  })}
                </div>
                {showFieldError && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      PhoneNumber: {
        render: ({
          label,
          showLabel,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  id={uuid}
                  required={required}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Email: {
        render: ({
          label,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  required={required}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Date: {
        render: ({
          label,
          required,
          errorMessage,
          hide,
          onChange,
          placeholder,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  onChange={onChange}
                />

                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                {/* <DateField /> */}
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Range: {
        render: ({ label, required, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                <Range />
              </div>
            </>
          );
        },
      },

      Toggle: {
        render: ({ label, required, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <div className="check-switch">
                  <label>No</label>
                  <input id="agree-check" type="checkbox" defaultChecked />
                  <label>Yes</label>
                </div>
              </div>
            </>
          );
        },
      },

      Button: {
        render: ({
          buttonText,
          buttonAction,
          conditionalLogic,
          buttonLink,
          buttonStyle,
          buttonicon,
          hide,
          uuid,
          customStyle,
          Style,
          spacing,
          iconPosition,
          popupTargetId,
          buttonAlignment,
          PageList,
          buttonValue,
        }) => {
          const buttonClickProps = {
            buttonAction,
            buttonValue,
            PageList,
            buttonLink,
            buttonText,
          };
          const handleButtonPress = () =>
            onButtonClick(uuid, null, buttonClickProps);
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          // Prepare conditional attributes for the Bootstrap modal
          const modalTriggerAttributes = {};
          if (buttonAction === "OpenPopup" && popupTargetId) {
            modalTriggerAttributes["data-bs-toggle"] = "modal";
            // Ensure popupTargetId from Puck field doesn't include '#'
            // Prepend '#' when setting data-bs-target
            modalTriggerAttributes[
              "data-bs-target"
            ] = `#${popupTargetId.replace(/^#/, "")}`;
          }

          return (
            <>
              <div
                className={`button-wrap text-${buttonAlignment}`}
                style={{ opacity: inputOpacity }}
              >
                {(() => {
                  if (buttonAction === "OpenPopup") {
                    return buttonicon === "yes" ? (
                      <button
                        // {...modalTriggerAttributes}
                        onClick={() => {
                          changeModal();
                        }}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        {...modalTriggerAttributes}
                        //data-bs-toggle="modal"
                        //data-bs-target="#reportModal"
                        onClick={() => onButtonClick(uuid, null, buttonClickProps)}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ClosePopup") {
                    return buttonicon === "yes" ? (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ResetForm") {

                    return buttonicon === "yes" ? (
                      <button
                        // onMouseDown={(e) => {
                        //   // Handle button logic here before blur/render happens
                        //   // e.preventDefault(); // optional: prevent focus loss
                        //   onButtonClick(uuid, "nothing");
                        // }}
                        //onClick={handleRecalculateClick} // Added onClick
                        data-bs-toggle="modal"
                        data-bs-target="#logoPrompt"

                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="roi-button-icon-2" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="roi-button-icon-2" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <div className="icon">
                              <Svg name="roi-button-icon" />
                            </div>
                          </>
                        )}
                      </button>
                    ) : (
                      <button // Added onClick
                        data-bs-toggle="modal"
                        data-bs-target="#logoPrompt"
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );

                  } else {
                    return buttonicon === "yes" ? (
                      <button
                        onMouseDown={(e) => {
                          handleButtonPress();
                        }}
                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="roi-button-icon-2" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="roi-button-icon-2" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <div className="icon">
                              <Svg name="roi-button-icon" />
                            </div>
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onButtonClick(uuid, "nothing 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  }
                })()}
              </div>
            </>
          );
        },
      },

      //Bootstrap modal component
      // Inside your config.js, for the BootstrapModal component:
      BootstrapModal: {
        render: ({ modalId, _editorPreviewContent, children, modalSize }) => {
          // This render function is for the Puck admin editor experience.
          return (
            <>
              {handleModalOpen && (
                <>
                  <div
                    class={`modal fade${handleModal ? "" : " show d-block"}`}
                    id={modalId}
                    tabindex="-1"
                    aria-labelledby={`${modalId}Label`}
                    aria-hidden="true"
                  >
                    <div
                      class={`modal-dialog modal-dialog-centered p-0 ${modalSize}`}
                    >
                      <div class="modal-content">
                        <div class="modal-body modal-body-roi-landing-form ">
                          <DropZone zone="wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show"></div>
                </>
              )}
            </>
          );
        },
      },
      ProgressBar: {
        render: ({
          value,
          minValue,
          maxValue,
          barColor,
          height,
          ariaLabel,
          puck,
        }) => {
          const percentage = ((value - minValue) / (maxValue - minValue)) * 100;
          const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

          const progressBarStyle = {
            width: `${clampedPercentage}%`,
          };
          if (barColor) {
            progressBarStyle.backgroundColor = barColor;
          }

          const progressContainerStyle = {};
          if (typeof height === "number") {
            // Check if height is a number
            progressContainerStyle.height = `${height}px`; // Append 'px'
          }

          return (
            <div
              className="progress"
              role="progressbar"
              aria-label={ariaLabel || "Progress bar"}
              aria-valuenow={value}
              aria-valuemin={minValue}
              aria-valuemax={maxValue}
              style={progressContainerStyle}
            >
              <div
                className="roi-progress-bar progress-bar"
                style={progressBarStyle}
              >
                {/* Label is removed */}
              </div>
            </div>
          );
        },
      },
      // Button: {
      //     render: ({ Button, hide }) => {
      //         // Render nothing if hide is true
      //         if (hide) {
      //             return null;
      //         }

      //         // Calculate opacity based on hide value
      //         const inputOpacity = hide ? 0.5 : 1;

      //         return (
      //             <>
      //                 <div className="button-wrap" style={{ opacity: inputOpacity }}>
      //                     {Button.buttonicon === "yes" ?

      //                         <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
      //                             <div className="icon">
      //                                 <Svg name="roi-button-icon" />
      //                             </div>
      //                         </button>
      //                         :
      //                         <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
      //                     }

      //                 </div>
      //             </>
      //         )

      //     },
      // },

      //Report
      ReportPage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="heading-currency-wrapper d-lg-flex mb-3 mb-lg-4 align-items-center">
                    <div className="curecny-dropdown mb-3 mb-lg-0 order-2">
                      <select
                        className="form-control form-select"
                        onChange={(e) => currencyChange(e)}
                      >
                        <option
                          value={defaultCurrency}
                          selected={
                            changedCurrency == "" ||
                              changedCurrency == defaultCurrency
                              ? "selected"
                              : ""
                          }
                        >
                          {defaultCurrency}
                        </option>
                        {currency.map((item, i) => (
                          <option
                            value={item}
                            selected={changedCurrency == item ? "selected" : ""}
                            key={i}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="section-heading flex-grow-1 order-1">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                  </div>
                  <div className="stats-section stats-section-custom">
                    <div className="row">
                      <div className="col-lg-8 mb-3 mb-lg-0">
                        <div className="total-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="total-wrapper" />
                        </div>
                        <div className="chart-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="chart-wrapper" />
                        </div>
                        <div className="custom-table-wrapper report-accordion-wrapper report-pg-table mb-3 mb-lg-4">
                          <DropZone zone="table-wrapper" />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="download-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="download-wrapper" />
                        </div>
                        <div className="card-wrapper-custom">
                          <DropZone zone="card-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-3" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={item.icon} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value1),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value2),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle3}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value3}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle4}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value4}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a
                            data-bs-toggle="modal"
                            data-bs-target="#reportModal"
                            onClick={() => onButtonClick(item.uuid)}
                            className="fs-16 fw-700"
                          >
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      ResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                <div className="total-inner bg-1">
                  <h5 className="fs-16 fw-700">{Card1.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card1.value) })}
                  </p>
                </div>
                <div className="total-inner bg-2">
                  <h5 className="fs-16 fw-700">{Card2.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card2.value) })}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      ChartCard: {
        render: ({ Heading, hide, Chart1, Chart2, Chart3, Chart4 }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon d-none">
                    <img src={Heading.icon} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>

                  <div className="switch-btn">
                    <div className="switch-nav">
                      <input
                        id="microsoft"
                        type="radio"
                        name="company"
                        value="microsoft"
                        checked={selectedCompany === "microsoft"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="microsoft">Microsoft</label>

                      <input
                        id="vbuc"
                        type="radio"
                        name="company"
                        value="vbuc"
                        checked={selectedCompany === "vbuc"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="vbuc">VBUC</label>
                    </div>

                    <div className="switch-nav">
                      <input
                        id="year1"
                        type="radio"
                        name="year"
                        value="year1"
                        checked={selectedYear === "year1"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year1"> First Year</label>

                      <input
                        id="year3"
                        type="radio"
                        name="year"
                        value="year3"
                        checked={selectedYear === "year3"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year3">Three Years </label>
                    </div>
                  </div>
                </div>

                <div className="stat-content-wrapper pt-4">
                  {selectedCompany === "vbuc" && selectedYear === "year1" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart1.items)}
                    />
                  )}
                  {selectedCompany === "vbuc" && selectedYear === "year3" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart2.items)}
                    />
                  )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year1" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart3.items)}
                      />
                    )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year3" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart4.items)}
                      />
                    )}
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCard: {
        render: ({ Heading, Padding, Button, image, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          // const jumpToReport = async () => {
          //     try {
          //         let newuuid =  uuidv4();
          //         let generateUrl = `/roi/${roiId}/report/${newuuid}`
          //         window.open(generateUrl, '_blank');

          //     } catch (error) {
          //     }
          // }

          // const jumpToReport = async () => {
          //     try{
          //     let data = JSON.stringify({
          //         "roi_submitted_master_data_id": roiId,
          //         "structure": JSON.stringify(roiActionArr), // Assuming roiActionArr contains some structure data
          //         "add_date_time": new Date().toISOString().slice(0, 19).replace('T', ' ')
          //       });

          //       // Axios request configuration
          //       let config = {
          //         method: 'post',
          //         maxBodyLength: Infinity,
          //         url: `${apiUrl}/roi-submit-data/create`,
          //         headers: {
          //           'Content-Type': 'application/json'
          //         },
          //         data: data
          //       };

          //       // Perform the Axios request
          //      axios.request(config)
          //         .then((response) => {
          //           try {
          //             let newuuid = uuidv4();
          //             let generateUrl = `/roi/${roiId}/report/${newuuid}`;

          //             // Call API to download PDF
          //             let data = JSON.stringify({
          //                 "url": `${frntUrl}${generateUrl}`,
          //                 "reportname": "sample_pdf"
          //             });

          //             let config = {
          //                 method: 'post',
          //                 maxBodyLength: Infinity,
          //                 // url: 'http://localhost:3005/frnt/downloadreportpdf',
          //                 url: `${apiUrl}/roi-pages/reportPageDownload`,
          //                 headers: {
          //                     'Content-Type': 'application/json'
          //                 },
          //                 data: data,
          //                 responseType: 'blob' // This ensures that the response is treated as a file (binary data)
          //             };

          //             // Make API request to download PDF
          //             const response = axios.request(config);

          //             // Create a link element, set URL to response, and trigger download
          //             const url = window.URL.createObjectURL(new Blob([response.data]));
          //             const link = document.createElement('a');
          //             link.href = url;
          //             link.setAttribute('download', 'report.pdf');
          //             document.body.appendChild(link);
          //             link.click();
          //             document.body.removeChild(link);

          //         } catch (error) {
          //         }
          //         })
          //         .catch((error) => {
          //           console.error('Error:', error);
          //         });}
          //         catch(error){
          //             console.error('Error with create:', error);
          //         }
          // };

          const jumpToReport = async () => {
            setIsLoadingdownload(true);
            try {
              // Use roiId as the submission ID to ensure only one entry per ROI
              const submissionId = roiId;
              const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");

              // Step 1: Create/update master data entry (upsert based on roi_id)
              const masterData = {
                roi_submitted_master_data_id: submissionId,
                roi_id: roiId,
                add_date_time: currentDateTime
              };

              await axios.post(`${apiUrl}/roi-submit-data/createMaster`, masterData, {
                headers: { "Content-Type": "application/json" }
              });

              // Step 2: Save/update the form data (upsert based on roi_submitted_master_data_id)
              let data = JSON.stringify({
                roi_submitted_master_data_id: submissionId,
                structure: JSON.stringify(roiActionArr_global.current),
                currency_symbol: JSON.stringify({
                  currencySymbol: currencySymbol,
                  currency: currency,
                }),
                add_date_time: currentDateTime,
              });

              // Configuration for the data API call
              let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-submit-data/create`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
              };

              // Perform the data API call
              const response = await axios.request(config);

              // Generate URL for PDF download using the submission ID (which is roiId)
              let generateUrl = `/roi/${roiId}/report/${submissionId}`;

              // Prepare data for PDF download API call
              data = JSON.stringify({
                url: `${frntUrl}${generateUrl}`,
                reportname: "sample_pdf",
              });

              // Configuration for PDF download API call
              config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-pages/reportPageDownload`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
                responseType: "blob",
              };

              // Perform PDF download API call
              const pdfResponse = await axios.request(config);

              // Create a link element, set URL to response, and trigger download
              const url = window.URL.createObjectURL(
                new Blob([pdfResponse.data])
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `report-${roiId}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error("Error in jumpToReport:", error);
            } finally {
              setIsLoadingdownload(false); // Stop loading when process is complete
            }
          };

          return (
            <>
              <div
                className={`save-report-section h-100 d-flex align-items-end`}
                style={{
                  backgroundImage: `url("${image}")`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  opacity: inputOpacity,
                  padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                }}
              >
                <div className="text-wrapper">
                  <h4
                    className={`${Heading?.fontWeight} ${Heading?.titleFont}`}
                    style={{
                      color: Heading?.Color,
                    }}
                  >
                    {Heading.title}
                  </h4>

                  {/* <div className="button-wrap">

                                        {Button.buttonicon === "yes" ?
                                            <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} onClick={jumpToReport}><span className='with-icon'>{Button.buttonText}</span>
                                                <div className="icon">
                                                    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </button>
                                            :
                                            <button className={`btn roi-btn-${Button.buttonStyle}`} onClick={jumpToReport}>{Button.buttonText}</button>
                                        }
                                    </div> */}
                  <div className="button-wrap">
                    {Button.buttonicon === "yes" ? (
                      <button
                        className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                        onClick={jumpToReport}
                        disabled={isLoadingdownload} // Disable button while loading
                      >
                        {isLoadingdownload ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <span className="with-icon">{Button.buttonText}</span>
                        )}
                        {!isLoadingdownload && (
                          <div className="icon">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62"
                                stroke="#25282B"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8 2.33334V13.5533"
                                stroke="#25282B"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </button>
                    ) : (
                      <button
                        className={`btn roi-btn-${Button.buttonStyle}`}
                        onClick={jumpToReport}
                        disabled={isLoadingdownload} // Disable button while loading
                      >
                        {isLoading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          Button.buttonText
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Report Single page

      ReportSection: {
        render: ({ Heading, Description, Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone={`summary-heading`} />
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <DropZone zone={`summary-details`} />
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="report-accordion-wrapper">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          {items.map((item, i) => (
                            <li
                              className="nav-item"
                              role="presentation"
                              key={i}
                            >
                              {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                              <button
                                className={
                                  item.isActive === true
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                onClick={() => openPopup(item.buttonValue)}
                              >
                                {item.Title}
                              </button>
                            </li>
                          ))}
                        </ul>
                        <div className="form-wrapper">
                          {/* <div className="tab-content" id="myTabContent"> */}
                          {/* {items.map((item, i) => ( */}
                          {/* <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}> */}

                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                          {/* </div> */}
                          {/* ))} */}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                {Heading?.title && (
                  <h2 className="fs-20 fw-700 accordion-button">
                    {Heading.title}
                  </h2>
                )}

                <div className="accordion-body report-accordion-wrapper">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => (
                            <tr
                              key={i}
                              className={`${Table.LastRow && `table-last-row`}`}
                            >
                              <td
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {item.Cell1isEditable ? (
                                  <input
                                    type="text"
                                    className="form-control first-column"
                                    defaultValue={item.Cell1Data}
                                    onFocus={handleInputFocus}
                                    onBlur={(e) =>
                                      handleInputBlur(item.Cell1uuid, e)
                                    }
                                  />
                                ) : (
                                  item.Cell1Data
                                )}
                              </td>

                              <td
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleInputBlur(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return item.Cell2Data + "%";
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell2Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleInputBlur(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell2Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleInputBlur(item.Cell2uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell2Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return item.Cell3Data + "%";
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell3Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell3Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleChange(item.Cell3uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell3Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return item.Cell4Data + "%";
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell4Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell4Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleChange(item.Cell4uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell4Data;
                                  }
                                })()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Download Report
      DownloadReportBanner: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          image,
          backgroundImage,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom
                    } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                  style={{
                    backgroundImage: `url("${backgroundImage}")`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="row align-items-center ">
                      <div className="col-lg-12">
                        <div className="banner-text">
                          <h1
                            className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                          >
                            {Heading.title}
                          </h1>

                          <div className="text-part">
                            <div
                              className={Description.descriptionFont}
                              dangerouslySetInnerHTML={{
                                __html: Description.text,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="img-wrapper">
                          <img src={image} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      DownloadReportPage: {
        render: ({ Heading, Description, Padding, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>

                    <div className="stats-section">
                      <div className="row">
                        <div className="col-lg-12 mb-2">
                          <DropZone zone="card-wrapper" />
                        </div>

                        <div className="col-lg-12 mb-2">
                          <DropZone zone="total-wrapper" />
                        </div>

                        <div className="col-lg-12">
                          <DropZone zone="chart-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row gx-2" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-2" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={item.icon} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value1}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value2}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a href="" className="fs-16 fw-700">
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      DownloadResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="total-wrapper row gx-0 flex-row"
                style={{ opacity: inputOpacity }}
              >
                <div className="total-inner bg-1 col-6">
                  <h5 className="fs-16 fw-700 text-center">{Card1.title}</h5>
                  <p className="fs-48 fw-300 text-center">
                    {Card1.description}
                  </p>
                </div>
                <div className="total-inner bg-2 col-6">
                  <h5 className="fs-16 fw-700 text-center">{Card2.title}</h5>
                  <p className="fs-48 fw-300 text-center">
                    {Card2.description}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadChartCard: {
        render: ({ Chart1, Chart2, Heading, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon">
                    <img src={Heading.icon} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>
                </div>

                <div className="stat-content-wrapper">
                  <div className="tab-content" id="myTabContent">
                    <div className="row">
                      <div className="col-sm-6">
                        {Chart1.chooseChart === "pie" ? (
                          <ReactEcharts
                            style={chartStyle}
                            option={OneYearChartOptions}
                          />
                        ) : (
                          <ReactEcharts
                            style={chartStyle}
                            option={ThreeYearChartOptions}
                          />
                        )}
                      </div>
                      <div className="col-sm-6">
                        {Chart2.chooseChart === "bar" ? (
                          <ReactEcharts
                            style={chartStyle}
                            option={ThreeYearChartOptions}
                          />
                        ) : (
                          <ReactEcharts
                            style={chartStyle}
                            option={OneYearChartOptions}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportSection: {
        render: ({ Heading, Description, Padding, items, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                    <div className="report-accordion-wrapper">
                      <div className="form-wrapper">
                        <div className="tab-content" id="myTabContent">
                          {items.map((item, i) => (
                            <div
                              key={i}
                              className={
                                i === 0
                                  ? "tab-pane fade show active"
                                  : "tab-pane fade"
                              }
                              id={`tab-${i}-pane`}
                              role="tabpanel"
                              aria-labelledby={`tab-${i}`}
                              tabIndex={0}
                            >
                              <div className="form-inner">
                                <DropZone
                                  zone={`wizard-form-wrapper-${i}`}
                                  disallow={["SinglePage", "WizardForm"]}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                <h2 className="fs-14 fw-700 accordion-button">
                  {Heading.title}
                </h2>
                <div className="accordion-body">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "1st"
                                    ? "highlighted"
                                    : ""
                                    }`}
                                >
                                  {item.Cell1isEditable ? (
                                    <input
                                      type="text"
                                      className="form-control first-column"
                                      defaultValue={item.Cell1Data}
                                      onFocus={handleInputFocus}
                                      onBlur={(e) =>
                                        handleChange(item.Cell1uuid, e)
                                      }
                                    />
                                  ) : (
                                    item.Cell1Data
                                  )}
                                </td>

                                <td
                                  className={`${ColumnSettings.HighlightCol === "2nd"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell2Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell2uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell2isEditable &&
                                      item.Cell2EditStyle === "percentage"
                                    ) {
                                      return item.Cell2Data + "%";
                                    } else if (
                                      !item.Cell2isEditable &&
                                      item.Cell2EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell2Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell2Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell2uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell2uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell2Data;
                                    }
                                  })()}
                                </td>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "3rd"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell3Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell3uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell3isEditable &&
                                      item.Cell3EditStyle === "percentage"
                                    ) {
                                      return item.Cell3Data + "%";
                                    } else if (
                                      !item.Cell3isEditable &&
                                      item.Cell3EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell3Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell3Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell3uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell3Data;
                                    }
                                  })()}
                                </td>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "4th"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell4Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell4uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell4isEditable &&
                                      item.Cell4EditStyle === "percentage"
                                    ) {
                                      return item.Cell4Data + "%";
                                    } else if (
                                      !item.Cell4isEditable &&
                                      item.Cell4EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell4Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell4Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell4uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell4Data;
                                    }
                                  })()}
                                </td>
                              </tr>
                            );
                            // }
                          })}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{items[items.length-1].Cell1}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportCardsSection: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          Lists,
          Settings,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                    <div className="report-posts-wrapper">
                      <div
                        className="list-box-1 d-grid gap-4"
                        style={{
                          gridTemplateColumns: `repeat(${Settings.ItemsPerRow}, 1fr)`,
                        }}
                      >
                        {Lists.map((list, i) => (
                          <div
                            className={`list-box-inner ${Settings.IconPosition === "left" ? "d-flex" : ""
                              }`}
                            key={i}
                          >
                            {Settings.ShowIcon ? (
                              <div className="icon-wrap">
                                <img src={list.Image} alt="" />
                              </div>
                            ) : (
                              ""
                            )}

                            <div className={`text-wrap flex-grow-1`}>
                              <h4
                                className={`${Settings.TitleFont} ${Settings.TitleFontWeight} mb-3`}
                                style={{ color: Settings.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.DescriptionFont} ${Settings.DescriptionFontWeight} mb-0`}
                              >
                                {list.Description}
                              </p>
                              {Settings.ShowButton ? (
                                <div className="button-wrap pt-3">
                                  <a
                                    className="link d-inline-flex text-primary fw-700 fs-14 align-items-center"
                                    href={list.ButtonLink}
                                  >
                                    <span>{list.ButtonText}</span>{" "}
                                    <Svg name="button-arrow" />
                                  </a>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportThankYou: {
        render: ({ logo, Description, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div className="report-build-wrapper report-thankyou">
                  <div className="logo-wrap">
                    <img src={logo} alt="" />
                  </div>
                  <div className="desclaimer">
                    <p className={Description.Font}>{Description.text}</p>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Landing Page components

      TransparentSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`landing-page-cpmponent ${Style.CustomClass} component-section ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      GradientSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`component-section gradient-bg ${Padding.bottom} ${Padding.top
                  } ${Padding.fullHeight && "full-height"}`}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      Columns: {
        render: ({
          columns,
          distribution,
          vertical,
          gap,
          Padding,
          Style,
          Border,
        }) => {
          return (
            <div
              className={`d-grid section-column ${vertical}`}
              style={{
                backgroundImage: `url("${Style?.Background}")`,
                backgroundColor: `${Style?.BackgroundColor}`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                borderStyle: Border?.BorderStyle,
                borderColor: Border?.BorderColor,
                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                borderRadius: `${Border?.BorderRadius}px`,

                gridTemplateColumns:
                  distribution === "manual"
                    ? "repeat(12, 1fr)"
                    : `repeat(${columns.length}, 1fr)`,
                gridColumnGap: `${gap}px`,
              }}
            >
              {columns.map(({ span, backgroundColor }, idx) => (
                <div
                  key={idx}
                  className="w-100"
                  style={{
                    display: "flex",
                    backgroundColor: backgroundColor,
                    flexDirection: "column",
                    gridColumn:
                      span && distribution === "manual"
                        ? `span ${Math.max(Math.min(span, 12), 1)}`
                        : "",
                  }}
                >
                  <DropZone
                    zone={`column-${idx}`}
                  // disallow={["Section"]}
                  />
                </div>
              ))}
            </div>
          );
        },
      },

      Wrapper: {
        render: ({ Padding, Style, Border, customClass, hide, uuid }) => {
          if (hide == true || hide == 'true') {
            return null;
          }
          return (
            <>
              <div
                className={`component-wrapper ${customClass}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                  borderStyle: Border.BorderStyle,
                  borderColor: Border.BorderColor,
                  borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                  borderRadius: `${Border.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`position-relative`}>
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      Spacing: {
        render: ({ Height }) => {
          return <div style={{ height: `${Height}` }}></div>;
        },
      },

      Heading: {
        render: ({ Text, Padding }) => {
          return (
            <>
              {(() => {
                if (Text.tag === "h1") {
                  return (
                    <h1
                      className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h1>
                  );
                } else if (Text.tag === "h2") {
                  return (
                    <h2
                      className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h2>
                  );
                } else if (Text.tag === "h3") {
                  return (
                    <h3
                      className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h3>
                  );
                } else if (Text.tag === "h4") {
                  return (
                    <h4
                      className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h4>
                  );
                } else if (Text.tag === "h5") {
                  return (
                    <h5
                      className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h5>
                  );
                } else if (Text.tag === "h6") {
                  return (
                    <h6
                      className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h6>
                  );
                }
              })()}
            </>
          );
        },
      },

      Text: {
        render: ({ Text }) => {
          // Parse the text for dynamic spans
          const parsedContent = parseDynamicText(Text.text);
          
          return (
            <>
              <div
                style={{
                  color: `${Text.Color}`,
                  textAlign: Text.Align,
                }}
                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`}
              >
                {parsedContent}
              </div>
            </>
          );
        },
      },

      Image: {
        render: ({ Image, AspectRatio, fullWidth }) => {
          return (
            <>
              <div className="image-wrapper">
                <img
                  src={Image}
                  alt=""
                  className={`img-fluid object-cover ${fullWidth && `w-100`} `}
                  style={{ aspectRatio: `${AspectRatio}` }}
                />
              </div>
            </>
          );
        },
      },

      RedCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-1">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      WhiteCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-2">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            {list.Image ? (
                              <div class="icon-wrapper">
                                <img
                                  src={list.Image}
                                  alt=""
                                  height={Settings.Card.IconSize}
                                  width={Settings.Card.IconSize}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      PieChart: {
        render: ({ chartOption }) => (
          <>
            <div className="echart-wrapper">
              <ReactEcharts
                style={{
                  height: "200px",
                  width: "100%",
                }}
                option={chartOption}
              />
            </div>
          </>
        ),
      },

      eCharts: {
        render: ({ Chart, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          // Special styling for roiId c51d1af0-0099-11ef-8e49-4bdeaebfbca1
          const isSpecialRoi = roiId === 'c51d1af0-0099-11ef-8e49-4bdeaebfbca1';

          const PieChartStyle = {
            height: isSpecialRoi ? "280px" : "330px",
            width: "100%",
          };

          const BarChartStyle = {
            height: "206px",
            width: "100%",
          };

          return (
            <>
              <div className="echart-wrap" style={{ opacity: inputOpacity }}>
                {(() => {
                  if (Chart.chooseChart === "pie") {
                    return (
                      <ReactEcharts
                        style={PieChartStyle}
                        option={pieEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  } else if (Chart.chooseChart === "bar") {
                    return (
                      <ReactEcharts
                        style={BarChartStyle}
                        option={barEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  }
                  return null;
                })()}
              </div>
            </>
          );
        },
      },

      ToggleSwitch: {
        render: ({ items, ID, hide, Margin, Style }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative d-flex align-items-center ${Style?.Alignment
                  }`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                <div
                  className={`roi-toggle-switch d-flex align-items-center`}
                  style={{
                    borderStyle: "solid",
                    borderColor: "#B6B7B8",
                    borderWidth: `1px 1px 1px 1px`,
                    borderRadius: `4px`,
                  }}
                >
                  {items.map((item, i) => (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input"
                        name={ID}
                        type="radio"
                        defaultValue
                        id={`${ID}-${i}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${ID}-${i}`}
                      >
                        {item.Option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        },
      },

      Collapsible: {
        render: ({ ID }) => {
          // Calculate opacity based on hide value
          // const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="collapse-header collapsed"
                data-bs-toggle="collapse"
                href={`#${ID}`}
                role="button"
                aria-expanded="false"
                aria-controls={`${ID}`}
              >
                <DropZone zone={`collapse-header`} />
                <div className="drop-icon">
                  <Svg name="collapsible-icon" />
                </div>
              </div>

              <div className="collapse-body collapse" id={`${ID}`}>
                <DropZone zone={`collapse-body`} />
              </div>
            </>
          );
        },
      },

      Collapsible2: {
        render: function FrontendCollapsible({ itemId, showText, hideText, headerText }) {
          // Props:
          // - itemId: The unique ID for this collapsible.
          // - showText / hideText: Labels from admin for collapsed / expanded states.
          // - headerText: Legacy static label (used only when showText/hideText are absent).

          const collapseRef = React.useRef(null);
          const buttonRef = React.useRef(null);

          const collapsedLabel = showText || "Show Details";
          const expandedLabel = hideText || "Hide Details";
          const isLegacyStaticLabel = headerText && !showText && !hideText;

          const getInitialButtonText = () => {
            if (isLegacyStaticLabel) {
              return headerText;
            }
            return collapsedLabel;
          };

          const [currentButtonText, setCurrentButtonText] = React.useState(
            getInitialButtonText()
          );

          React.useEffect(() => {
            const collapsibleElement = collapseRef.current;
            const triggerButton = buttonRef.current;

            if (!collapsibleElement || !triggerButton) {
              return; // Exit if refs are not yet set
            }

            const updateTextBasedOnState = () => {
              if (isLegacyStaticLabel) {
                setCurrentButtonText(headerText);
                return;
              }
              if (collapsibleElement.classList.contains("show")) {
                setCurrentButtonText(expandedLabel);
              } else {
                setCurrentButtonText(collapsedLabel);
              }
            };

            // Bootstrap event listeners to update text after animations complete
            const handleShown = () => updateTextBasedOnState();
            const handleHidden = () => updateTextBasedOnState();

            collapsibleElement.addEventListener(
              "shown.bs.collapse",
              handleShown
            );
            collapsibleElement.addEventListener(
              "hidden.bs.collapse",
              handleHidden
            );

            // Initial text update in case the component mounts in an unexpected state
            // or if 'show' class was somehow added initially by other means.
            updateTextBasedOnState();

            // Cleanup: remove event listeners when the component unmounts or dependencies change
            return () => {
              collapsibleElement.removeEventListener(
                "shown.bs.collapse",
                handleShown
              );
              collapsibleElement.removeEventListener(
                "hidden.bs.collapse",
                handleHidden
              );
            };
          }, [itemId, showText, hideText, headerText, collapsedLabel, expandedLabel, isLegacyStaticLabel]);

          const collapseId = `collapse-${itemId}`; // Unique ID for the Bootstrap content div
          const headingId = `heading-${itemId}`; // Unique ID for the Bootstrap header

          // Frontend default: start collapsed. Bootstrap JS handles adding/removing 'show'.
          const collapseClasses = ["accordion-collapse", "collapse"];
          const initialAriaExpanded = "false";
          const initialButtonClassName = "accordion-button collapsed";

          return (
            <div className="accordion-item details-accordion">
              <h2 className="accordion-header" id={headingId}>
                <button
                  ref={buttonRef}
                  className={initialButtonClassName}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={initialAriaExpanded}
                  aria-controls={collapseId}
                >
                  {currentButtonText}
                </button>
              </h2>
              <div
                ref={collapseRef}
                id={collapseId}
                className={collapseClasses.join(" ")}
                aria-labelledby={headingId}
              // If you implement accordion groups via a 'parentId' prop from admin:
              // data-bs-parent={props.parentId ? `#${props.parentId.replace(/^#/, '')}` : undefined}
              >
                <div className="accordion-body">
                  <DropZone zone="content" />
                </div>
              </div>
            </div>
          );
        },
      },

      IconUploader: {
        render: ({
          iconFile,
          iconFallbackUrl,
          iconWidth,
          iconHeight,
          puck,
        }) => {
          // Helper to prepare src for img tag (handles raw SVG and data URLs)
          const getDisplaySrc = (imgValue) => {
            if (
              typeof imgValue === "string" &&
              imgValue.trim().startsWith("<svg")
            ) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
                imgValue
              )}`;
            }
            return imgValue; // Assumes it's already a data URL or external URL
          };

          const primarySrc = getDisplaySrc(iconFile);
          const fallbackSrc = getDisplaySrc(iconFallbackUrl); // Fallback could also be raw SVG

          const imgSrc = primarySrc || fallbackSrc;
          const displayWidth = iconWidth || 24;
          const displayHeight = iconHeight || 24;

          return (
            <div>
              {imgSrc ? (
                <img
                  src={imgSrc}
                  alt="Icon"
                  style={{
                    width: `${displayWidth}px`,
                    height: `${displayHeight}px`,
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    verticalAlign: "middle",
                  }}
                />
              ) : (
                puck &&
                puck.isEditing && (
                  <span style={{ fontSize: "10px", color: "#aaa" }}>
                    No Icon
                  </span>
                )
              )}
            </div>
          );
        },
      },

      ResultsPageHeader: {
        render: ({ logo, hide, showDownloadButton, showRecalculateButton, contactUsButtonLink, recalculateButtonText, contactUsButtonText, downloadButtonText }) => {
          const inputOpacity = hide ? 0.5 : 1;

          const handleRecalculateClick = (event) => {
            // Find the icon element within the clicked button
            // This is a bit more direct DOM traversal
            const button = event.currentTarget;
            const iconDiv = button.querySelector(".icon"); // Assumes .icon is the direct child or descendant

            if (iconDiv) {
              // Check if animation is already running to prevent re-triggering too fast
              if (iconDiv.classList.contains("recalculate-icon-rotate")) {
                return;
              }

              iconDiv.classList.add("recalculate-icon-rotate");

              // Remove the class after animation completes
              setTimeout(() => {
                iconDiv.classList.remove("recalculate-icon-rotate");
              }, 500); // Must match your CSS animation duration (0.5s = 500ms)
            }

          };


          const jumpToReport = async () => {
            setIsLoadingdownload(true);
            try {
              // Use roiId as the submission ID to ensure only one entry per ROI
              const submissionId = roiId;
              const currentDateTime = new Date().toISOString().slice(0, 19).replace("T", " ");

              // Step 1: Create/update master data entry (upsert based on roi_id)
              const masterData = {
                roi_submitted_master_data_id: submissionId,
                roi_id: roiId,
                add_date_time: currentDateTime
              };

              await axios.post(`${apiUrl}/roi-submit-data/createMaster`, masterData, {
                headers: { "Content-Type": "application/json" }
              });

              // Step 2: Save/update the form data (upsert based on roi_submitted_master_data_id)
              let data = JSON.stringify({
                roi_submitted_master_data_id: submissionId,
                structure: JSON.stringify(roiActionArr_global.current),
                currency_symbol: JSON.stringify({
                  currencySymbol: currencySymbol,
                  currency: currency,
                }),
                add_date_time: currentDateTime,
              });

              // Configuration for the data API call
              let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-submit-data/create`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
              };

              // Perform the data API call
              const response = await axios.request(config);

              // Generate URL for PDF download using the submission ID (which is roiId)
              let generateUrl = `/roi/${roiId}/report/${submissionId}`;

              // Prepare data for PDF download API call
              data = JSON.stringify({
                url: `${frntUrl}${generateUrl}`,
                reportname: "sample_pdf",
              });

              // Configuration for PDF download API call
              config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-pages/reportPageDownload`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
                responseType: "blob",
              };

              // Perform PDF download API call
              const pdfResponse = await axios.request(config);

              // Create a link element, set URL to response, and trigger download
              const url = window.URL.createObjectURL(
                new Blob([pdfResponse.data])
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `report-${roiId}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error("Error in jumpToReport:", error);
            } finally {
              setIsLoadingdownload(false); // Stop loading when process is complete
            }
          };


          return (
            <div
              className={`roi-header-main`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={logo} alt="" />
                    ) : (
                      <img src={logo_fallback} alt="" />
                    )}
                  </a>
                  <div className="flex-grow-1">
                    {(showDownloadButton || showRecalculateButton) && ( // Use && for cleaner conditional rendering
                      <div className="d-flex currency-language">
                        {showRecalculateButton && (
                          <button
                            title={recalculateButtonText || "Recalculate"}
                            className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3"
                            onClick={handleRecalculateClick}
                            data-bs-toggle="modal"
                            data-bs-target="#logoPrompt"
                          >
                            <div className="icon">
                              {" "}
                              {/* This div will get the animation class */}
                              <Svg name="roi-recalculate-icon" />
                            </div>
                            {recalculateButtonText || ""}
                          </button>
                        )}

                        {contactUsButtonLink && <>
                          <a target="_blank" href={contactUsButtonLink} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3">{contactUsButtonText || "Contact Us"}
                          </a>
                        </>}
                        {showDownloadButton && (

                          <button
                            className={`d-inline-flex align-items-center btn roi-btn-primary gap-3`}
                            onClick={jumpToReport}
                            disabled={isLoadingdownload} // Disable button while loading
                          >
                            {isLoadingdownload ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              </>
                            ) : (
                              <>
                                {downloadButtonText || "Download Report"}
                                <div className="icon">
                                  <Svg name="roi-download-icon" />
                                </div>
                              </>
                            )}

                          </button>

                        )}

                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      Separator: {

        render: ({ color, height, margin }) => {
          return (
            <div className="separator" style={{ backgroundColor: color, height: `${height}px`, margin: `${margin?.top}px ${margin?.right}px ${margin?.bottom}px ${margin?.left}px` }}>

            </div>
          )
        },
      },
    },
  };

  //currency change
  const currencyChange = async (e) => {
    let currency_selected = e.target.value;
    let current_currency = "USD";
    let current_symbol = "$";
    let exchange_rate = 1;
    let calculated_arr_global = [];
    let updatedRoiActionArr = JSON.parse(JSON.stringify(roiActionArr_global.current));

    const response = await fetch(`${apiUrl}/roi-currency/list`);
    const result = await response.json();
    const res = result.data;

    Object.keys(res).map((key) => {
      if (res[key].currency_name == currency_selected) {
        current_currency = res[key].currency_name;
        exchange_rate = res[key].exchange_rate;
        current_symbol = res[key].symbol;
      }
    });
    // let currency_rate = currencyRates[currency_selected];
    let changedCurrency__ = changedCurrency ? changedCurrency : defaultCurrency;
    if (
      (changedCurrency__ == "USD" && changedCurrency__ != current_currency) ||
      (defaultCurrency == "USD" &&
        changedCurrency__ == "" &&
        current_currency != "USD")
    ) {
      await Object.keys(roiActionArr_global.current).map((key) => {
        if (
          roiActionArr_global.current[key].value != 0 &&
          key != "" &&
          typeof roiActionArr_global.current[key].value == "number" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(updatedRoiActionArr[key].value * exchange_rate),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(roiActionArr_global.current[key].value * exchange_rate).toFixed(
              2
            ),
          });
        } else if (
          roiActionArr_global.current[key].value != 0 &&
          typeof roiActionArr_global.current[key].value == "string" &&
          key != "" &&
          !isNaN(roiActionArr_global.current[key].value) &&
          roiActionArr_global.current[key].value !== "" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(
                parseFloat(updatedRoiActionArr[key].value) * exchange_rate
              ),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              parseFloat(roiActionArr_global.current[key].value) * exchange_rate
            ).toFixed(2),
          });
        }
      });
    }

    if (
      changedCurrency__ != "USD" &&
      changedCurrency__ != current_currency &&
      changedCurrency__ != ""
    ) {
      await Object.keys(roiActionArr_global.current).map((key) => {
        if (
          roiActionArr_global.current[key].value != 0 &&
          key != "" &&
          typeof roiActionArr_global.current[key].value == "number" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value:
                (updatedRoiActionArr[key].value / exchangeRate) * exchange_rate,
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              parseFloat(roiActionArr_global.current[key].value / exchangeRate) * exchange_rate
            ).toFixed(2),
          });
        } else if (
          roiActionArr_global.current[key].value != 0 &&
          typeof roiActionArr_global.current[key].value == "string" &&
          key != "" &&
          !isNaN(roiActionArr_global.current[key].value) &&
          roiActionArr_global.current[key].value !== "" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(
                (parseFloat(updatedRoiActionArr[key].value) / exchangeRate) *
                exchange_rate
              ),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              (parseFloat(roiActionArr_global.current[key].value) / exchangeRate) *
              exchange_rate
            ).toFixed(2),
          });
        }
      });
    }
    setChangedCurrency(current_currency);
    setCurrencySymbol(current_symbol);
    setExchangeRate(exchange_rate);

    //now create global array and pass it to update all uuid
    await updateValueForRenderAllPages(calculated_arr_global);
  };

  //redirect to home page
  const homeRedirect = () => {
    window.location.reload();
  };

  const [handleModalOpen, setHandleModalOpen] = useState(false);
  const changeModal = () => {
    setHandleModalOpen(true);
  };

  // Recursive function to get values by ID
  function getFormValuesById(container) {
    const result = {};

    function traverse(node) {
      if (node instanceof HTMLInputElement) {
        if (node.id) {
          if (node.type === 'checkbox') {
            result[node.id] = node.checked;
          } else if (node.type === 'radio') {
            if (node.checked) {
              result[node.id] = node.value;
            }
          } else {
            result[node.id] = node.value;
          }
        }
      } else if (node instanceof HTMLTextAreaElement) {
        if (node.id) {
          result[node.id] = node.value;
        }
      } else if (node instanceof HTMLSelectElement) {
        if (node.id) {
          if (node.multiple) {
            const selected = Array.from(node.selectedOptions).map(opt => opt.value);
            result[node.id] = selected;
          } else {
            result[node.id] = node.value;
          }
        }
      } else {
        Array.from(node.children).forEach(child => traverse(child));
      }
    }

    traverse(container);
    return result;
  }


  //for button or link
  const onButtonClick =
    async (uuid, place, clickedProps = null) => {
      //extracting form values from the page
      //condition added because handleChange is not working on button click
      let formValues = syncFormValuesToGlobalState();
      let form_assign_arr = {};

      Object.keys(formValues).forEach((elementId) => {
        if (
          elementId !== "" &&
          elementId !== undefined &&
          elementId !== null &&
          formValues[elementId] !== undefined &&
          formValues[elementId] !== null
        ) {
          const { entry: currentEntry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            elementId,
            currentPageId.current
          );
          if (!currentEntry) {
            return;
          }

          if (currentEntry.value !== formValues[elementId]) {
            form_assign_arr[elementId] = {
              uuid: elementId,
              value: formValues[elementId],
            };
          }
        }
      });
      //for updating button is clicked
      const clickPageId = currentPageId.current;
      const clickScopedKey = getScopedRoiKey(clickPageId, uuid);
      const clickEntry =
        roiActionArr_global.current[clickScopedKey] ||
        getRoiActionEntry(clickPageId, uuid) ||
        { roi_page_id: clickPageId };

      roiActionArr_global.current = {
        ...roiActionArr_global.current,
        [clickScopedKey]: {
          ...clickEntry,
          value: 1,
        },
      };
      if (roiActionArr_global.current[uuid]?.roi_page_id === clickPageId) {
        roiActionArr_global.current = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: 1,
          },
        };
      }

      const actionEntry = getRoiActionEntry(currentPageId.current, uuid);
      const liveActionProps =
        clickedProps ||
        resolveActionPropsFromPage(currentPageId.current, uuid);

      if (!actionEntry && !liveActionProps) {
        console.warn("[onButtonClick] No action entry found for uuid:", uuid, {
          currentPageId: currentPageId.current,
        });
        return;
      }

      const actionType = liveActionProps?.buttonAction || actionEntry?.actions;
      const resolvedActionId = liveActionProps
        ? getButtonPageId(liveActionProps)
        : actionEntry?.action_id;

      console.log("[onButtonClick] action resolved", {
        uuid,
        currentPageId: currentPageId.current,
        source: clickedProps ? "render-props" : "page-structure-lookup",
        buttonText: liveActionProps?.buttonText,
        buttonValue: liveActionProps?.buttonValue,
        PageList: liveActionProps?.PageList,
        resolvedActionId,
        globalActionId: actionEntry?.action_id,
      });

      if (actionType === "JumpToPage") {
        if (!resolvedActionId) {
          console.error("[JumpToPage] Missing target page on current page structure", {
            uuid,
            currentPageId: currentPageId.current,
            liveActionProps,
            actionEntry,
            roiId,
          });
          return;
        }
        if (
          actionEntry?.action_id &&
          resolvedActionId !== actionEntry.action_id
        ) {
          console.warn("[JumpToPage] Using current page structure (ignoring stale global map)", {
            uuid,
            currentPageId: currentPageId.current,
            globalActionId: actionEntry.action_id,
            resolvedActionId,
          });
        }
        jumpToPage(resolvedActionId, form_assign_arr);
      } else if (actionType === "JumpToUrl") {
        // condition for jump to url
        let link = actionEntry?.link;
        window.open(link, "_blank");
      } else if (actionType === "OpenPopup") {
        //condition for jump to page
        openPopup(resolvedActionId || actionEntry?.action_id, form_assign_arr);
      } else if (actionType === "JumpToReport") {
        //condition for jump to page
        jumpToReport(form_assign_arr);
      }
    };

  const jumpToReport = async () => {
    try {
    } catch (error) {
      console.error("Error with GET request:", error);
    }
  };

  const jumpToPage =
    async (id, assign_arr) => {
      try {
        const targetPageId = typeof id === "string" ? id.trim() : id;
        if (!targetPageId || !normalizePageStructureString(roipages.current[targetPageId])) {
          console.error("[JumpToPage] Target page not found in loaded pages", {
            targetPageId,
            fromPageId: currentPageId.current,
            availablePageIds: Object.keys(roipages.current),
            roiId,
            apiUrl,
            pagesApi: `${apiUrl}/roi-pages/detail/${roiId}`,
          });
          return;
        }

        const elements = getRoiGlobalElementKeys(roiActionArr_global.current);
        const currentPageElements = elements.filter(
          (element) =>
            resolveRoiVariableEntry(
              roiActionArr_global.current,
              element,
              currentPageId.current
            ).entry?.roi_page_id === currentPageId.current
        );
        const hasRequiredOnCurrentPage = currentPageElements.some((element) => {
          const { entry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            element,
            currentPageId.current
          );
          const props = resolveActionPropsFromPage(currentPageId.current, element);
          return isRoiFieldRequired(entry, props);
        });
        const hasInputValidationOnPage = collectPageInputFields(
          currentPageId.current
        ).some((field) => {
          const { entry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            field.uuid,
            currentPageId.current
          );
          return shouldValidateEmptyField(entry, field.props);
        });
        const hasRadioValidationOnPage = collectPageRadioFields(
          currentPageId.current
        ).some((field) => {
          const { entry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            field.uuid,
            currentPageId.current
          );
          return shouldValidateEmptyField(entry, field.props);
        });
        const hasConditionalLogic =
          Object.keys(allCondtionalLogicData.current || {}).length > 0;

        if (
          !hasRequiredOnCurrentPage &&
          !hasInputValidationOnPage &&
          !hasRadioValidationOnPage &&
          !hasConditionalLogic
        ) {
          currentPageId.current = targetPageId;
          renderChanges(assign_arr || {}, {}, {}, targetPageId);
          return;
        }

        let checkRequired = true;
        const elements_by_page_id_current =
          elements_by_page_id.current[currentPageId.current] || [];
        let error_messages = {};

        // Sync live DOM values before validation
        syncFormValuesToGlobalState();

        // Clear existing errors for all fields on current page when Next button is clicked
        const clearErrorMessages = {};
        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          if (roiActionArr_global.current[element].roi_page_id == currentPageId.current) {
            clearErrorMessages[element] = {
              'uuid': element,
              'errorMessage': "",
              'validationError': false,
            };
          }
        }

        // IMPORTANT: Process business logic first to get updated values
        // Then process conditional errors based on the updated values
        let process_arr = await processLogic();
        
        // Merge cleared error messages first
        error_messages = mergeUpdatesByUUID(error_messages, clearErrorMessages);

        let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
        if (Object.keys(error_messages_conditional).length > 0) {
          for (const key of Object.keys(error_messages_conditional)) {
            if (error_messages_conditional[key].errorMessage == "") {
              delete error_messages_conditional[key];
            }
          }
          if (Object.keys(error_messages_conditional).length > 0) {
            error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
            checkRequired = false;
          }

        }


        const pageInputFields = collectPageInputFields(currentPageId.current);
        for (const field of pageInputFields) {
          const { entry: fieldEntry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            field.uuid,
            currentPageId.current
          );
          if (!fieldEntry) {
            continue;
          }

          const fieldProps =
            field.props ||
            resolveActionPropsFromPage(currentPageId.current, field.uuid);

          if (
            shouldValidateEmptyField(fieldEntry, fieldProps) &&
            isInputFieldEmpty(fieldEntry, field.componentType)
          ) {
            const errorMessage = getConfiguredFieldErrorMessage(
              fieldEntry,
              fieldProps,
              getValidationDefaultMessage("requiredField")
            );
            checkRequired = false;
            error_messages[field.uuid] = {
              uuid: field.uuid,
              errorMessage: errorMessage,
              validationError: true,
            };

            applySharedUuidState(field.uuid, { errorMessage: errorMessage });
            roiActionArr_global.current = {
              ...roiActionArr_global.current,
              [field.uuid]: {
                ...(roiActionArr_global.current[field.uuid] || fieldEntry),
                errorMessage: errorMessage,
                validationError: true,
              },
            };
          }
        }

        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          const { entry: fieldEntry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            element,
            currentPageId.current
          );
          if (!fieldEntry) {
            continue;
          }

          const fieldProps = resolveActionPropsFromPage(currentPageId.current, element);
          const fieldType = fieldEntry.type || fieldProps?.type || "";

          if (
            fieldEntry.roi_page_id != undefined &&
            isRoiFieldRequired(fieldEntry, fieldProps) &&
            fieldEntry.value == 0 &&
            fieldType == "Checkbox Option" &&
            fieldEntry.roi_page_id == currentPageId.current
          ) {
            const checkboxId = fieldEntry.checkbox_id;
            const checkboxProps = resolveActionPropsFromPage(currentPageId.current, checkboxId);
            const checkboxEntry = resolveRoiVariableEntry(
              roiActionArr_global.current,
              checkboxId,
              currentPageId.current
            ).entry;
            let errorMessage = getConfiguredFieldErrorMessage(
              checkboxEntry,
              checkboxProps,
              getValidationDefaultMessage("checkbox")
            );
            checkRequired = false;
            error_messages[checkboxId] = {
              // pageId: currentPageId.current,
              'uuid': checkboxId,
              'errorMessage': errorMessage,
              'validationError': true,
            };
            
            // Also update the global state with the error message
            roiActionArr_global.current[checkboxId] = {
              ...roiActionArr_global.current[checkboxId],
              errorMessage: errorMessage,
              validationError: true,
            };
          }
        }

        const pageRadioFields = collectPageRadioFields(currentPageId.current);
        for (const field of pageRadioFields) {
          const { entry: fieldEntry } = resolveRoiVariableEntry(
            roiActionArr_global.current,
            field.uuid,
            currentPageId.current
          );
          if (!fieldEntry) {
            continue;
          }

          const fieldProps =
            field.props ||
            resolveActionPropsFromPage(currentPageId.current, field.uuid);

          if (
            shouldValidateEmptyField(fieldEntry, fieldProps) &&
            isRadioFieldEmpty(fieldEntry, fieldProps)
          ) {
            const errorMessage = getConfiguredFieldErrorMessage(
              fieldEntry,
              fieldProps,
              getValidationDefaultMessage("radio")
            );
            checkRequired = false;
            error_messages[field.uuid] = {
              uuid: field.uuid,
              errorMessage: errorMessage,
              validationError: true,
            };

            applySharedUuidState(field.uuid, { errorMessage: errorMessage });
            roiActionArr_global.current = {
              ...roiActionArr_global.current,
              [field.uuid]: {
                ...(roiActionArr_global.current[field.uuid] || fieldEntry),
                errorMessage: errorMessage,
                validationError: true,
              },
            };
          }
        }

        if (!checkRequired) {
          renderChanges(assign_arr, error_messages, process_arr);
        } else {
          currentPageId.current = targetPageId;
          renderChanges(assign_arr, error_messages, process_arr, targetPageId);
        }

      } catch (error) {
        console.error("Error with GET request:", error);
      }
    };

  const openPopup = async (id) => {
    try {
      //setRenderModalData(JSON.parse(roipages[id]));

      setCurrentPopupPageId(id);
      setPopupStatus(true);
    } catch (error) {
      console.error("Error with GET request:", error);
    }
  };

  const refreshParentPage = async () => {
    setCurrentPopupPageId("");
    setPopupStatus(false);
  };


  const evaluateConditionError = (condition) => {
    let value = condition["value"] ?? "";
    const operator = condition["operator"] ?? "";
    const value_type = condition["value_type"] ?? "";
    if (value_type == "dynamic") {
      value = resolveRoiVariableEntry(
        roiActionArr_global.current,
        value,
        currentPageId.current
      ).entry?.value;
    }
    const variable = condition["variable"] ?? "";

    let return__ = false;
    const variableEntry = resolveRoiVariableEntry(
      roiActionArr_global.current,
      variable,
      currentPageId.current
    ).entry;
    if (variableEntry?.value != undefined) {
      switch (operator) {
        case "==":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(parseFloat(variableEntry.value) == value);
          }
          break;
        case "!=":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(parseFloat(variableEntry.value) != value);
          }
          break;
        case ">":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(parseFloat(variableEntry.value) > value);
          }
          break;
        case "<":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(parseFloat(variableEntry.value) < value);
          }
          break;
        case ">=":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(parseFloat(variableEntry.value) >= value);
          }
          break;
        case "<=":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(parseFloat(variableEntry.value) <= value);
          }
          break;
        case "is empty":
          return__ = isEmpty(variableEntry.value);
          break;
        case "is not empty":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = !isEmpty(variableEntry.value);
          }
          break;
        case "is":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(variableEntry.value === value);
          }
          break;
        case "is not":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = eval(variableEntry.value !== value);
          }
          break;
        case "contains":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = variableEntry.value.includes(value);
          }
          break;
        case "does not contain":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = !variableEntry.value.includes(value);
          }
          break;
        case "starts with":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = variableEntry.value.startsWith(value);
          }
          break;
        case "does not start with":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = !variableEntry.value.startsWith(value);
          }
          break;
        case "ends with":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = variableEntry.value.endsWith(value);
          }
          break;
        case "does not end with":
          if (variableEntry.value != undefined &&
            variableEntry.value != null &&
            variableEntry.value != ""
          ) {
            return__ = !variableEntry.value.endsWith(value);
          }
          break;
        default:
          return__ = false;
      }
    }
    return return__;
  };

  const evaluateCondition = (condition) => {
    // Validate input condition
    if (!condition || typeof condition !== 'object') {
      console.warn('evaluateCondition: Invalid condition object:', condition);
      return false;
    }
    
    let value = condition["value"] ?? "";
    const operator = condition["operator"] ?? "";
    const value_type = condition["value_type"] ?? "";
    const variable_data_type = condition["variable_data_type"] ?? "text";
    
    if (value_type == "dynamic") {
      value = resolveRoiVariableEntry(
        roiActionArr_global.current,
        value,
        currentPageId.current
      ).entry?.value;
    }
    const variable = condition["variable"] ?? "";

    let return__ = false;
    const variableEntry = resolveRoiVariableEntry(
      roiActionArr_global.current,
      variable,
      currentPageId.current
    ).entry;
    if (variableEntry?.value != undefined) {
      // Get the variable value and convert based on data type
      let variableValue = variableEntry.value;
      let compareValue = value;
      
      // Convert values based on variable_data_type
      if (variable_data_type === "number") {
        variableValue = parseFloat(variableValue) || 0;
        compareValue = parseFloat(compareValue) || 0;
      }
      
      // console.log(`Evaluating condition: ${variable}(${variableValue}) ${operator} ${compareValue} [${variable_data_type}]`);
      
      switch (operator) {
        case "==":
          if (variable_data_type === "number") {
            return__ = variableValue === compareValue;
          } else {
            return__ = variableValue == compareValue;
          }
          break;
        case "!=":
          if (variable_data_type === "number") {
            return__ = variableValue !== compareValue;
          } else {
            return__ = variableValue != compareValue;
          }
          break;
        case ">":
          if (variable_data_type === "number") {
            return__ = variableValue > compareValue;
          } else {
            return__ = variableValue > compareValue;
          }
          break;
        case "<":
          if (variable_data_type === "number") {
            return__ = variableValue < compareValue;
          } else {
            return__ = variableValue < compareValue;
          }
          break;
        case ">=":
          if (variable_data_type === "number") {
            return__ = variableValue >= compareValue;
          } else {
            return__ = variableValue >= compareValue;
          }
          break;
        case "<=":
          if (variable_data_type === "number") {
            return__ = variableValue <= compareValue;
          } else {
            return__ = variableValue <= compareValue;
          }
          break;
        case "is empty":
          return__ = isEmpty(variableValue);
          break;
        case "is not empty":
          return__ = !isEmpty(variableValue);
          break;
        case "is":
          return__ = variableValue === compareValue;
          break;
        case "is not":
          return__ = variableValue !== compareValue;
          break;
        case "contains":
          return__ = String(variableValue).includes(String(compareValue));
          break;
        case "does not contain":
          return__ = !String(variableValue).includes(String(compareValue));
          break;
        case "starts with":
          return__ = String(variableValue).startsWith(String(compareValue));
          break;
        case "does not start with":
          return__ = !String(variableValue).startsWith(String(compareValue));
          break;
        case "ends with":
          return__ = String(variableValue).endsWith(String(compareValue));
          break;
        case "does not end with":
          return__ = !String(variableValue).endsWith(String(compareValue));
          break;
        default:
          return__ = false;
      }
      
      // console.log(`Condition result: ${return__}`);
    }
    return return__;
  };

  const isEmpty = (value) => {
    return (
      value === null || // check for null
      value === undefined || // check for undefined
      value === "" || // check for empty string
      (Array.isArray(value) && value.length === 0) || // check for empty array
      (typeof value === "object" &&
        value !== null &&
        Object.keys(value).length === 0) // check for empty object
    );
  };

  //function to return error messages for conditional logics getting true for show_error action
  // This function handles both showing and clearing error messages based on conditional logic
  // 
  // EXECUTION ORDER: This function MUST be called AFTER processLogic() to ensure
  // it evaluates conditions based on the most up-to-date values from business logic.
  // 
  // IMPORTANT: Page re-rendering is considered by:
  // 1. Using for...of loops instead of async forEach to ensure proper execution order
  // 2. Preserving error states during re-renders via renderChanges function
  // 3. Synchronizing error states between global state and error_messages collection
  // 4. Only clearing errors when necessary to prevent unnecessary state updates
  const processConditionalError = async (page_elements) => {
    let error_messages = {};
    let logics = allCondtionalLogicData.current;

    // Safety check: ensure page_elements is defined and is an array
    if (!page_elements || !Array.isArray(page_elements)) {
      console.warn('processConditionalError: page_elements is undefined or not an array:', page_elements);
      return error_messages;
    }

    // Use for...of loops instead of forEach with async to ensure proper execution order
    for (const element of Object.keys(logics)) {
      for (const element1 of Object.keys(logics[element])) {
        const { when, when_and_or_operator, then } = logics[element][element1];

        let conditionResult = when_and_or_operator === "AND" ? true : false;

        for (const condition of when) {
          const result = evaluateConditionError(condition);
          if (when_and_or_operator === "AND") {
            conditionResult = conditionResult && result;
          } else {
            conditionResult = conditionResult || result;
          }
        }

        if (conditionResult) {
          for (const action of then) {
            const {
              action: type,
              value,
              variable,
              variable_data_type,
              operator: action_type,
              value_type,
              value_variable_selected_option
            } = action;
            if (page_elements.includes(variable)) {
              switch (type) {
                case "show_error":
                  let val_error = roiActionArr_global.current[value_variable_selected_option['value']]?.value;
                  let value__ = value.replace("#value#", val_error);

                  // Show error message when condition is true
                  roiActionArr_global.current[variable] = {
                    ...roiActionArr_global.current[variable],
                    errorMessage: value__,
                    validationError: true,
                  };

                  error_messages[variable] = {
                    'uuid': variable,
                    'errorMessage': value__,
                    'validationError': true,
                  };

                  break;

                default:

              }
            }
          }
        }

        if (!conditionResult) {
          for (const action of then) {
            const {
              action: type,
              value,
              variable,
              variable_data_type,
              operator: action_type,
              value_type,
              value_variable_selected_option
            } = action;
            if (page_elements.includes(variable)) {
              switch (type) {
                case "show_error":
                  // Clear error message when condition is false
                  // Only clear if the element currently has an error message to prevent unnecessary updates
                  if (roiActionArr_global.current[variable]?.errorMessage) {
                    roiActionArr_global.current[variable] = {
                      ...roiActionArr_global.current[variable],
                      errorMessage: "",
                      validationError: false,
                    };

                    error_messages[variable] = {
                      'uuid': variable,
                      'errorMessage': "",
                      'validationError': false,
                    };
                  }
                  break;

                default:

              }
            }
          }
        }
      }
    }

    // Ensure error states are properly synchronized between global state and error_messages
    // This prevents loss of error states during re-renders
    Object.keys(error_messages).forEach(uuid => {
      if (error_messages[uuid].errorMessage && !roiActionArr_global.current[uuid]?.errorMessage) {
        // If error_messages has an error but global state doesn't, sync it
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: error_messages[uuid].errorMessage,
          validationError: error_messages[uuid].validationError === true,
        };
      } else if (!error_messages[uuid].errorMessage && roiActionArr_global.current[uuid]?.errorMessage) {
        // If global state has an error but error_messages doesn't, sync it
        error_messages[uuid].errorMessage = roiActionArr_global.current[uuid].errorMessage;
        error_messages[uuid].validationError =
          roiActionArr_global.current[uuid]?.validationError === true;
      }
    });

    return error_messages;
  };

  function applyThenActions(thenArr, roiActionArr__, jumpToPage, rule) {
    let calculated_arr = {};
    let updatedMap = { ...roiActionArr__ };
    const preferredPageId = currentPageId.current;
    // console.log("updatedMap", rule, updatedMap);
    for (const action of Object.keys(thenArr)) {
      const {
        action: type,
        value,
        variable,
        variable_data_type,
        operator: action_type,
        value_type,
        value_variable_selected_option,
      } = thenArr[action];

      const variableResolved = resolveRoiVariableEntry(
        updatedMap,
        variable,
        preferredPageId
      );
      const variableEntry = variableResolved.entry;

      const currentVal = variableEntry?.value;
      const currency = variableEntry?.currency;
      const hidden = variableEntry?.hide;
      
      // Log warning if variable doesn't exist in the map
      if (!variableEntry) {
        console.warn(`Warning: Variable ${variable} not found in roiActionArr for action type ${type}`);
        continue; // Skip this action if the variable doesn't exist
      }

      // ----------------- CALCULATE ACTION -----------------
      if (type === "calculate") {
        const isNumber = variable_data_type === "number";

        let base = isNumber ? parseFloat(currentVal || "0") : currentVal || "";
        let operand =
          value_type === "static"
            ? isNumber ? (isNaN(parseFloat(value)) ? value : parseFloat(value)) : value
            : (() => {
                const operandResolved = resolveRoiVariableEntry(
                  updatedMap,
                  value,
                  preferredPageId
                );
                const operandEntry = operandResolved.entry;
                return isNumber
                  ? parseFloat(operandEntry?.value || "0")
                  : operandEntry?.value || "";
              })();

        // console.log(`Calculate action: ${variable} [${variable_data_type}] - Base: ${base}, Operand: ${operand}, Operator: ${action_type}`);

        let result = base;

        switch (action_type) {
          case "assign":
            result = operand;
            break;
          case "add":
            result = base + operand;
            break;
          case "subtract":
            result = base - operand;
            break;
          case "multiply":
            result = base * operand;
            break;
          case "divide":
            result = operand !== 0 ? base / operand : base;
            break;
          default:
            continue;
        }

        const resultStr = isNumber
          ? parseFloat(result).toFixed(acceptDecimals ? 2 : 0)
          : result;

        // console.log(`Calculate result: ${variable} = ${resultStr} [${variable_data_type}]`);
        
        const allowUpdate =
          resultStr !== currentVal &&
          currentVal !== undefined;
        // console.log("allowUpdate", allowUpdate, rule);

        if (allowUpdate && variableEntry) {
          updatedMap = patchRoiVariableEntry(
            updatedMap,
            variable,
            preferredPageId,
            { value: resultStr }
          );
          calculated_arr[variable] = {
            ...(calculated_arr[variable] || {}),
            value: resultStr
          };
          
          // console.log(`Updated ${variable} from ${currentVal} to ${resultStr}`);
          
          // Check if this is updating a span UUID
          if (variable === "fa69d63f-f107-492a-90de-f3368e3f3f36") {
            // console.log("*** SPAN UUID UPDATED! This should trigger dynamic span re-render ***");
          }
        }
      }

      // ----------------- SHOW BLOCKS -----------------
      if (type === "show_blocks") {
        if (hidden !== "false" && variableEntry) {
          updatedMap = patchRoiVariableEntry(
            updatedMap,
            variable,
            preferredPageId,
            { hide: "false" }
          );
          calculated_arr[variable] = {
            ...(calculated_arr[variable] || {}),
            hide: "false"
          };
        }
      }

      // ----------------- HIDE BLOCKS -----------------
      if (type === "hide_blocks") {
        if (hidden !== "true" && variableEntry) {
          updatedMap = patchRoiVariableEntry(
            updatedMap,
            variable,
            preferredPageId,
            { hide: "true" }
          );
          calculated_arr[variable] = {
            ...(calculated_arr[variable] || {}),
            hide: "true"
          };
        }
      }

      // ----------------- JUMP TO PAGE -----------------
      if (type === "jump_to_page" && typeof jumpToPage === "function") {
        if (value && normalizePageStructureString(roipages.current[value])) {
          jumpToPage(value);
        } else {
          console.warn("[JumpToPage] Skipping conditional jump to unknown page:", value);
        }
      }

      // (Skip "show_error", "disable_item", etc. by request)
    }

    return {
      updatedRoiActionArr: updatedMap,
      calculated_arr: calculated_arr,
    };
  }


  const processLogic = async (jumpToPage) => {
    let logics = allCondtionalLogicData.current;
    // console.log("=== PROCESSING CONDITIONAL LOGIC ===");
    // console.log("Available logic rules:", Object.keys(logics));
    // console.log("Full conditional logic data:", logics);
    let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr_global.current));

    let hasChanges = true;
    let calculated_arr_global = {};
    let count = 0;
    while (hasChanges) {
      hasChanges = false;

      for (const rule of Object.keys(logics)) {
        try {
          // console.log(`\n--- Processing Rule: ${rule} ---`);
          
          // Validate rule structure
          if (!logics[rule] || !Array.isArray(logics[rule]) || logics[rule].length === 0) {
            console.warn(`Rule ${rule}: Invalid rule structure:`, logics[rule]);
            continue;
          }
          
          const { when, when_and_or_operator, then } = logics[rule][0];
          // console.log("When conditions:", when);
          // console.log("Then actions:", then);

          // Validate that conditions exist and are properly structured
          if (!when || typeof when !== 'object') {
            console.warn(`Rule ${rule}: Invalid 'when' conditions structure:`, when);
            continue;
          }

          let conditionResult = when_and_or_operator === "AND" ? true : false;

        for (const condition of Object.keys(when)) {
          // console.log(`\nEvaluating condition ${condition}:`, when[condition]);
          const result = evaluateCondition(when[condition], rule);
          // console.log(`Condition ${condition} result: ${result}`);
          
          if (when_and_or_operator === "AND") {
            conditionResult = conditionResult && result;
          } else {
            conditionResult = conditionResult || result;
          }
        }

        // console.log(`Final condition result for rule ${rule}: ${conditionResult}`);
        
        if (conditionResult) {
          // console.log(`Rule ${rule} conditions met - executing actions`);
          try {
            // Validate that 'then' actions exist and are properly structured
            if (!then || typeof then !== 'object') {
              console.warn(`Rule ${rule}: Invalid 'then' actions structure:`, then);
              continue;
            }
            
            const { updatedRoiActionArr, calculated_arr: localChanges } = applyThenActions(then, roiActionArr__, jumpToPage, rule);
            // console.log("Local changes from actions:", localChanges);

            for (const key of Object.keys(localChanges)) {
              // Safety check: ensure both objects exist and have the expected structure
              if (roiActionArr__[key] && localChanges[key] && 
                  localChanges[key].value !== undefined && 
                  roiActionArr__[key].value !== undefined &&
                  localChanges[key].value == roiActionArr__[key].value) {
                delete localChanges[key];
              }
            }

            if (Object.keys(localChanges).length > 0) {
              // console.log(`Applying changes for rule ${rule}:`, localChanges);
              roiActionArr__ = updatedRoiActionArr;
              calculated_arr_global = { ...calculated_arr_global, ...localChanges };
              hasChanges = true;
            } else {
              // console.log(`No changes to apply for rule ${rule}`);
            }
          } catch (error) {
            console.error(`Error processing actions for rule ${rule}:`, error);
            // Continue processing other rules instead of crashing
          }
        } else {
          // console.log(`Rule ${rule} conditions not met - skipping actions`);
        }
        } catch (error) {
          console.error(`Error processing rule ${rule}:`, error);
          // Continue processing other rules instead of crashing
        }
      }
      count++;
      // console.log(`\n--- Logic iteration ${count} complete ---`);
      if (count > 10) {
        // console.log("Maximum iterations reached, stopping logic processing");
        hasChanges = false;
      }
    }

    // console.log("=== CONDITIONAL LOGIC PROCESSING COMPLETE ===");
    // console.log("Final calculated changes:", calculated_arr_global);
    // console.log("Total rules processed:", count);
    
    // Update the global array with calculated values
    roiActionArr_global.current = roiActionArr__;
    
    // Check if any span values were updated
    if (Object.keys(calculated_arr_global).length > 0) {
      // console.log("Conditional logic updated values - re-render will be triggered by renderChanges");
    }
    
    return calculated_arr_global;
  };


  function debounce(func, delay) {
    let timer;
    return function (...args) {
      const context = this; // Capture context if needed (useful for non-arrow functions)
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }


  //need to change
  const updateValueByUuid =
    async (pageUuid, elementUuid, newValue) => {
      // Function to traverse and update the page data
      let level = 0;
      const traverseAndUpdate = async (data) => {
        if (Array.isArray(data)) {
          const results = await Promise.all(
            data.map((item) => traverseAndUpdate(item))
          );
          return results;
        } else if (data !== null && typeof data === "object") {
          const newObj = {};
          for (const key of Object.keys(data)) {
            if (data.hasOwnProperty("Cell1Data")) {
              // Check if the object has the key 'Cell1Data' for table data
              const value = data[key];
              let check_digit = 0;
              if (value == elementUuid) {
                const regex = /(\d+)/;
                const digit = key.match(regex);
                newObj["Cell" + digit[0] + "Data"] = newValue;
                newObj["Cell" + digit[0] + "uuid"] = value;
                check_digit = digit[0];
              } else if (value != elementUuid) {
                if (check_digit != 0 && key == "Cell" + check_digit + "Data") {
                } else {
                  newObj[key] = value;
                }
              }
            } else {

              const value = data[key];
              if (key === "uuid" && value === elementUuid && data.hasOwnProperty("value")) {
                newObj[key] = value; // keep uuid the same
                newObj["value"] = newValue; // update the value
                newObj["errorMessage"] = "";
                if (data.hasOwnProperty("errorMessage")) {
                  roiActionArr_global.current[elementUuid]["errorMessage"] = "";
                }
              } else if ((key !== "errorMessage" && key !== "value" && data["uuid"] == elementUuid) || data["uuid"] != elementUuid) {
                level++;
                if (typeof value === "object") {
                  newObj[key] = await traverseAndUpdate(value);
                } else {
                  // FIX: Only update value for the item with matching UUID
                  // This ensures each checkbox option is checked/unchecked independently
                  if (key === "Option" && data["uuid"] === elementUuid) {
                    newObj["value"] = newValue;
                  }
                  newObj[key] = value;
                }
              } else if (key === "value" && newObj["value"] === undefined) {
                newObj["value"] = data[key];
              }
            }
          }
          return newObj;
        } else {
          return data;
        }
      };

      // Update every page structure that contains this UUID so duplicated
      // fields stay in sync across pages.
      const pageIdsToUpdate = Object.keys(roipages.current).filter((pageId) => {
        const structure = normalizePageStructureString(roipages.current[pageId]);
        return structure && structure.includes(elementUuid);
      });

      for (const targetPageId of pageIdsToUpdate) {
        let pagedata = clonePagesMap(roipages.current);
        const parsedPage = parsePageStructure(pagedata[targetPageId]);
        if (!parsedPage) {
          console.warn("[ROI] Cannot update page with invalid structure:", targetPageId);
          continue;
        }
        const updatedPage = await traverseAndUpdate(parsedPage);
        roipages.current = setPageStructure(
          roipages.current,
          targetPageId,
          updatedPage
        );
      }

      if (pageIdsToUpdate.length > 0) {
        renderChanges();
      }
    };

  //need to change
  const updateValueForRenderAllPages =

    async (calculated_arr_global) => {

      if (calculated_arr_global.length > 0) {
        // Function to traverse and update the page data
        let level = 0;
        const traverseAndUpdate = async (
          data,
          calculated_arr_global,
          pageUuid
        ) => {
          if (Array.isArray(data)) {
            const results = await Promise.all(
              data.map((item) =>
                traverseAndUpdate(item, calculated_arr_global, pageUuid)
              )
            );
            return results;
          } else if (data !== null && typeof data === "object") {

            const newObj = {};
            for (const key of Object.keys(data)) {

              if (data.hasOwnProperty("Cell1Data")) {
                // Check if the object has the key 'Cell1Data' for table data
                const value = data[key];
                let check__ = false;
                let check_digit = 0;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (value == calculated_arr_global[element].variable) {
                //       const regex = /(\d+)/;
                //       const digit = key.match(regex);
                //       newObj["Cell" + digit[0] + "Data"] =
                //         calculated_arr_global[element].value;
                //       newObj["Cell" + digit[0] + "uuid"] = value;
                //       check_digit = digit[0];
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (value == calculated_arr_global[element].variable) {
                    const regex = /(\d+)/;
                    const digit = key.match(regex);
                    newObj["Cell" + digit[0] + "Data"] =
                      calculated_arr_global[element].value;
                    newObj["Cell" + digit[0] + "uuid"] = value;
                    check_digit = digit[0];
                    check__ = true;
                  }
                }

                if (check__ == false) {
                  // if (value != element.variable) {
                  if (check_digit != 0 && key == "Cell" + check_digit + "Data") {
                  } else {
                    newObj[key] = value;
                  }
                  // }
                }
              } else if (data.hasOwnProperty("Value1")) {
                // Check if the object has the key 'Cell1Data' for table data
                const value = data[key];
                let check__ = false;
                let check_digit = 0;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (value == calculated_arr_global[element].variable) {
                //       const regex = /(\d+)/;
                //       const digit = key.match(regex);
                //       newObj["Value" + digit[0]] =
                //         calculated_arr_global[element].value;
                //       newObj["Value" + digit[0] + "uuid"] = value;
                //       check_digit = digit[0];
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (value == calculated_arr_global[element].variable) {
                    const regex = /(\d+)/;
                    const digit = key.match(regex);
                    newObj["Value" + digit[0]] =
                      calculated_arr_global[element].value;
                    newObj["Value" + digit[0] + "uuid"] = value;
                    check_digit = digit[0];
                    check__ = true;
                  }
                }

                if (check__ == false) {
                  // if (value != element.variable) {
                  if (check_digit != 0 && key == "Value" + check_digit) {
                  } else {
                    newObj[key] = value;
                  }
                  // }
                }
              } else {

                const value = data[key];
                let check__ = false;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (
                //       key === "uuid" &&
                //       value === calculated_arr_global[element].variable &&
                //       data.hasOwnProperty("value")
                //     ) {
                //       newObj[key] = value; // keep uuid the same
                //       newObj["value"] = calculated_arr_global[element].value; // update the value
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (
                    key === "uuid" &&
                    value === calculated_arr_global[element].variable
                  ) {

                    if (data.hasOwnProperty("value")) {
                      newObj[key] = value; // keep uuid the same
                      newObj["value"] = calculated_arr_global[element].value; // update the value
                    }

                    // Fix: Check if hide property exists in calculated_arr_global, regardless of its value
                    if (data.hasOwnProperty('hide') && calculated_arr_global[element].hasOwnProperty('hide')) {
                      newObj[key] = value; // keep uuid the same
                      newObj["hide"] = calculated_arr_global[element]["hide"];
                    }
                    if (data.hasOwnProperty('errorMessage') && calculated_arr_global[element].hasOwnProperty('errorMessage')) {
                      newObj[key] = value; // keep uuid the same
                      newObj["errorMessage"] = calculated_arr_global[element]["errorMessage"];
                    }
                    check__ = true;
                  }
                }
                if (check__ == false) {
                  if (key !== "value" && key !== "hide" && key !== "errorMessage") { // Prevent overwriting hide property
                    if (typeof value === "object") {
                      newObj[key] = await traverseAndUpdate(
                        value,
                        calculated_arr_global,
                        pageUuid
                      );
                    } else {
                      newObj[key] = value;
                    }
                  } else if (key === "value" && newObj["value"] === undefined) {

                    newObj["value"] = data[key];

                  } else if (key === "hide" && !newObj.hasOwnProperty("hide")) {
                    // Only set hide from original data if it wasn't already set from calculated_arr_global
                    newObj["hide"] = data[key];
                  } else if (key === "errorMessage" && !newObj.hasOwnProperty("errorMessage")) {
                    // Only set errorMessage from original data if it wasn't already set from calculated_arr_global
                    newObj["errorMessage"] = data[key];
                  }
                }


              }
            }


            return newObj;
          } else {
            return data;
          }
        };

        // Only update the specific page
        let roipages__ = clonePagesMap(roipages.current);
        // Object.keys(roipages__).forEach(async (pageUuid, index) => {
        //   let pagedata = JSON.parse(JSON.stringify(roipages__));

        //   let updatedPage = await traverseAndUpdate(
        //     JSON.parse(pagedata[pageUuid]),
        //     calculated_arr_global,
        //     pageUuid
        //   );

        //   roipages__[pageUuid] = JSON.stringify(updatedPage);
        //   if (index == Object.keys(roipages__).length - 1) {
        //     setRoipages(roipages__);

        //   }
        // });

        const pageUuids = Object.keys(roipages__);
        for (const pageUuid of pageUuids) {
          let pagedata = JSON.parse(JSON.stringify(roipages__));
          let updatedPage = await traverseAndUpdate(
            JSON.parse(pagedata[pageUuid]),
            calculated_arr_global,
            pageUuid
          );
          roipages__ = setPageStructure(roipages__, pageUuid, updatedPage);
        }
        roipages.current = roipages__;
        renderChanges();
      }

    };

  // Helper function to check if a field is likely numeric
  const isFieldNumeric = (uuid) => {
    const field = roiActionArr_global.current[uuid];
    if (!field) return false;
    
    // Check if the field has a numeric type indicator
    if (field.type === "number" || field.variable_data_type === "number") {
      return true;
    }
    
    // Check if current value is numeric
    if (field.value && !isNaN(parseFloat(field.value)) && isFinite(field.value)) {
      return true;
    }
    
    return false;
  };

  // Helper function to prevent negative values in numeric fields
  const preventNegativeInput = (uuid, key) => {
    if (key === '-' && isFieldNumeric(uuid)) {
      return false; // Prevent minus key
    }
    return true; // Allow other keys
  };

  // Helper function to prevent scroll and arrow key changes in numeric fields
  const preventScrollAndArrowKeys = (e) => {
    // Prevent arrow keys from changing the value
    if (e.type === 'keydown') {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        return false;
      }
    }
    
    return true;
  };

  // Helper function specifically for preventing mouse wheel scroll
  const preventWheelScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };

  // Enhanced wheel event handler with passive: false
  const handleWheelEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // More aggressive wheel prevention
  const handleWheelPrevention = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };

  //for inputs type text
  const handleChange =
    async (uuid, e, required = false) => {
      console.log('handleChange called with uuid:', uuid, 'value:', e.target.value);
      console.log('Current roiActionArr_global.current:', roiActionArr_global.current);
      
      // Check for negative values in numeric inputs
      // Only apply this validation if the field appears to be numeric
      // Use the helper function for consistency
      const isLikelyNumeric = () => {
        // First check using the helper function
        if (isFieldNumeric(uuid)) {
          return true;
        }
        
        // Additional check: if the new value without minus would be numeric
        const newValueWithoutMinus = e.target.value.replace('-', '');
        if (newValueWithoutMinus && !isNaN(parseFloat(newValueWithoutMinus)) && isFinite(newValueWithoutMinus)) {
          return true;
        }
        
        return false;
      };

      if (e.target.value.startsWith('-') && isLikelyNumeric()) {
        // Prevent negative values for numeric fields - set error message and return early
        let errorMessage = "Negative values are not allowed for this field";
        let error_messages = {};
        error_messages[uuid] = {
          'uuid': uuid,
          'errorMessage': errorMessage,
          'validationError': true,
        };

        setFieldValidationState(uuid, {
          errorMessage: errorMessage,
          validationError: true,
        });
        applySharedUuidState(uuid, {
          value: e.target.value,
        });
        
        // Debug: Print current state
        console.log('roiActionArr_global.current:', roiActionArr_global.current);
        console.log('Current input value:', e.target.value);
        console.log('Is negative value?', e.target.value.startsWith('-'));

        let assign_arr = {}
        assign_arr[uuid] = {
          'uuid': uuid,
          'value': e.target.value
        };

        // Render changes with error message
        renderChanges(assign_arr, error_messages, {});
        return; // Exit early to prevent further processing
      }

      // Clear negative value error if it was previously set and user has removed the minus sign
      if (
        resolveRoiVariableEntry(roiActionArr_global.current, uuid, currentPageId.current)
          .entry?.errorMessage === "Negative values are not allowed for this field" &&
          !e.target.value.startsWith('-')
      ) {
        clearFieldValidationState(uuid);
      }

      if (e.target.value == "" && required == true) {
        applySharedUuidState(uuid, { value: "" });

        let assign_arr = {}
        assign_arr[uuid] = {
          'uuid': uuid,
          'value': ""
        };

        let process_arr = await processLogic();

        let error_messages = {};
        error_messages[uuid] = {
          uuid: uuid,
          errorMessage: "",
          validationError: false,
        };

        renderChanges(assign_arr, error_messages, process_arr);
      } else {
        if (
          uuid !== "" &&
          uuid !== undefined &&
          uuid !== null &&
          e !== "" &&
          e !== undefined &&
          e !== null
        ) {

          const currentEntry = resolveRoiVariableEntry(
            roiActionArr_global.current,
            uuid,
            currentPageId.current
          ).entry;

          if (!currentEntry) {
            console.warn("handleChange: UUID not found in roiActionArr:", uuid);
            return;
          }

          if (currentEntry.value == e.target.value) {
            return;
          }

          applySharedUuidState(uuid, {
            value: e.target.value,
          });
          clearFieldValidationState(uuid);

          await updateValueByUuid(currentPageId.current, uuid, e.target.value);

          let assign_arr = {};
          assign_arr[uuid] = {
            'uuid': uuid,
            'value': e.target.value
          };

          // console.log("=== TRIGGERING CONDITIONAL LOGIC AFTER INPUT CHANGE ===");
          // console.log("Input UUID:", uuid);
          // console.log("New value:", e.target.value);
          
          // IMPORTANT: Process business logic first to get updated values
          // Then process conditional errors based on the updated values
          let process_arr = await processLogic();

          const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
          let error_messages = {};

          error_messages[uuid] = {
            'uuid': uuid,
            'errorMessage': "",
            'validationError': false,
          };

          let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
          if (Object.keys(error_messages_conditional).length > 0) {
            error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
          }

          if (popupStatus == false) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
          if (popupStatus == true) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
        }
      }
    }

  //for checkbox
  const onCheckBoxClick =
    async (uuid) => {
      // Guard: Skip if UUID is empty or undefined
      if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
        console.warn('onCheckBoxClick called with invalid UUID:', uuid);
        return;
      }
      
      // Guard: Check if the UUID exists in roiActionArr
      const currentEntry = resolveRoiVariableEntry(
        roiActionArr_global.current,
        uuid,
        currentPageId.current
      ).entry;

      if (!currentEntry) {
        console.warn('onCheckBoxClick: UUID not found in roiActionArr:', uuid);
        return;
      }
      
      let value = currentEntry.value;
      if (value == "1") {
        value = "0";
        applySharedUuidState(uuid, { value });
        await updateValueByUuid(currentPageId.current, uuid, value);
      } else {
        value = "1";
        applySharedUuidState(uuid, { value });
        await updateValueByUuid(currentPageId.current, uuid, value);
      }

      // Clear error for the parent checkbox group if it exists
      let error_messages = {};
      const parentCheckboxId = currentEntry.checkbox_id;
      if (parentCheckboxId) {
        clearFieldValidationState(parentCheckboxId);
        error_messages[parentCheckboxId] = {
          uuid: parentCheckboxId,
          errorMessage: "",
          validationError: false,
        };
      }

      error_messages[uuid] = {
        uuid: uuid,
        errorMessage: "",
      };

      // IMPORTANT: Process business logic first to get updated values
      // Then process conditional errors based on the updated values
      let process_arr = await processLogic();

      const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
      let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
      if (Object.keys(error_messages_conditional).length > 0) {
        error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
      }

      // Render changes with cleared error messages
      let assign_arr = {};
      assign_arr[uuid] = {
        'uuid': uuid,
        'value': value
      };

      renderChanges(assign_arr, error_messages, process_arr);
    };


  //for radio
  const onRadioClick =
    async (uuid, value) => {
      // Guard: Skip if UUID is empty or undefined
      if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
        console.warn('onRadioClick called with invalid UUID:', uuid);
        return;
      }
      
      // Guard: Check if the UUID exists in roiActionArr
      const { entry: currentEntry } = resolveRoiVariableEntry(
        roiActionArr_global.current,
        uuid,
        currentPageId.current
      );

      if (!currentEntry) {
        console.warn('onRadioClick: UUID not found in roiActionArr:', uuid);
        return;
      }
      
      if (value > "0") {
        applySharedUuidState(uuid, { value });
        await updateValueByUuid(currentPageId.current, uuid, value);

        clearFieldValidationState(uuid);

        let assign_arr = {};
        assign_arr[uuid] = {
          uuid: uuid,
          value: value,
        };

        let error_messages = {};
        error_messages[uuid] = {
          uuid: uuid,
          errorMessage: "",
          validationError: false,
        };

        let process_arr = await processLogic();

        const elements_by_page_id_current =
          elements_by_page_id.current[currentPageId.current] || [];
        let error_messages_conditional = await processConditionalError(
          elements_by_page_id_current
        );
        if (Object.keys(error_messages_conditional).length > 0) {
          error_messages = mergeUpdatesByUUID(
            error_messages,
            error_messages_conditional
          );
        }

        renderChanges(assign_arr, error_messages, process_arr);
      }
    };

  // Handle input focus to clear default '0' values and store focus for tab index
  const handleInputFocus = (e) => {
    const input = e.target;
    // Only clear if the value is exactly '0' (default value)
    if (input.value === '0') {
      input.value = '';
    }
    // Store the focused input ID for tab index management
    setFocusedInputId(input.id);
  };

  // Handle input blur and restore focus after rerender
  const handleInputBlur = async (uuid, e, required = false) => {
    // Defer state update to next tick so browser can move focus naturally
    const event = { target: { value: e.target.value } };
    setTimeout(() => {
      handleChange(uuid, event, required);
    }, 0);
  };

  const handleDropdownChange =
    async (uuid, e) => {
      const changedArr = {
        ...changedDropdown,
        [uuid]: e.target.value,
      };
      setChangedDropdown(changedArr);

      const updatedRoiActionArr = syncSharedUuidState(
        roiActionArr_global.current,
        uuid,
        { value: e.target.value }
      );
      roiActionArr_global.current = updatedRoiActionArr;
      await updateValueByUuid(currentPageId.current, uuid, e.target.value);
    };

  const getButtonPageId = (props) =>
    props?.buttonValue || props?.PageList || "";

  const getRoiActionEntry = (pageId, uuid) =>
    resolveRoiVariableEntry(roiActionArr_global.current, uuid, pageId).entry;

  const dedupeFlatRoiGlobalKeys = (store) => {
    const uuidToScoped = {};

    Object.keys(store)
      .filter((key) => key.includes("::"))
      .forEach((scopedKey) => {
        const uuid = scopedKey.slice(scopedKey.indexOf("::") + 2);
        if (!uuidToScoped[uuid]) uuidToScoped[uuid] = [];
        uuidToScoped[uuid].push(scopedKey);
      });

    Object.entries(uuidToScoped).forEach(([uuid, scopedKeys]) => {
      let shared = store[uuid] ? pickSharedUuidState(store[uuid]) : {};

      scopedKeys.forEach((scopedKey) => {
        const scopedShared = pickSharedUuidState(store[scopedKey]);
        SHARED_UUID_STATE_FIELDS.forEach((field) => {
          if (
            (shared[field] === undefined || shared[field] === "") &&
            scopedShared[field] !== undefined &&
            scopedShared[field] !== ""
          ) {
            shared[field] = scopedShared[field];
          }
        });
      });

      const baseEntry = store[uuid] || store[scopedKeys[0]] || {};
      store[uuid] = { ...baseEntry, ...shared };

      scopedKeys.forEach((scopedKey) => {
        store[scopedKey] = { ...store[scopedKey], ...shared };
      });
    });
  };

  const assignRoiGlobalEntry = (store, pageId, uuid, entry) => {
    if (!uuid || !entry) return;

    const scopedKey = getScopedRoiKey(pageId, uuid);
    const sharedFromFlat = store[uuid] ? pickSharedUuidState(store[uuid]) : {};
    const scopedEntry = {
      ...entry,
      ...sharedFromFlat,
      roi_page_id: pageId,
    };

    store[scopedKey] = scopedEntry;

    if (!store[uuid]) {
      store[uuid] = { ...scopedEntry };
      return;
    }

    store[uuid] = {
      ...store[uuid],
      ...pickSharedUuidState(scopedEntry),
    };
    store[scopedKey] = { ...store[scopedKey], ...pickSharedUuidState(store[uuid]) };
  };

  const resetCalculatorState = () => {
    roipages.current = {};
    roiActionArr_global.current = {};
    elements_by_page_id.current = {};
    allCondtionalLogicData.current = [];
    globalRoiArr.current = [];
    currentPageId.current = null;
  };

  const getRoiGlobalElementKeys = (store = roiActionArr_global.current) =>
    Object.keys(store).filter((key) => !key.includes("::"));

  const resyncActionEntriesFromPages = (pages, store) => {
    pages.forEach((page) => {
      const pageId = page.roi_page_id;
      const structure = parsePageStructure(page.structure);
      if (!structure) return;

      const registerProps = (props, meta = {}) => {
        if (!props?.uuid) return;
        const scopedKey = getScopedRoiKey(pageId, props.uuid);
        const samePageFlat =
          store[props.uuid]?.roi_page_id === pageId ? store[props.uuid] : {};
        const existing = store[scopedKey] || samePageFlat || {};

        const entry = {
          count: 0,
          currency: "0",
          required: false,
          type: "",
          actions: "",
          action_id: "",
          link: "",
          value: "",
          default_value: "",
          hide: "false",
          errorMessage: "",
          ...existing,
          ...meta,
          roi_page_id: pageId,
        };

        if (props.buttonAction) {
          entry.actions = props.buttonAction;
          entry.action_id = getButtonPageId(props);
          entry.link = props.buttonLink ?? "";
        }

        assignRoiGlobalEntry(store, pageId, props.uuid, entry);
      };

      const registerDerivedFieldUuid = (uuid, meta = {}) => {
        if (!uuid) return;
        const scopedKey = getScopedRoiKey(pageId, uuid);
        const samePageFlat =
          store[uuid]?.roi_page_id === pageId ? store[uuid] : {};
        const existing = store[scopedKey] || samePageFlat || store[uuid] || {};

        assignRoiGlobalEntry(store, pageId, uuid, {
          count: 0,
          currency: "0",
          required: false,
          type: "",
          actions: "",
          action_id: "",
          link: "",
          value: "",
          default_value: "",
          hide: "false",
          errorMessage: "",
          ...existing,
          ...meta,
          roi_page_id: pageId,
        });
      };

      const registerNestedFieldUuids = (props, componentType = "") => {
        if (!props || typeof props !== "object") return;

        if (Array.isArray(props.items)) {
          props.items.forEach((item) => {
            if (!item || typeof item !== "object") return;

            if (item.uuid) {
              registerProps(item, {
                value: item.value ?? "",
                default_value: item.default_value ?? "",
                hide: item.hide ?? "false",
                errorMessage: item.errorMessage ?? "",
              });
            }

            if (componentType === "DownloadReportTable" || componentType === "ReportTable") {
              const cols = props?.Table?.Columns || 20;
              for (let col = 1; col <= cols; col++) {
                const cellUuid = item[`Cell${col}uuid`];
                if (!cellUuid) continue;
                registerDerivedFieldUuid(cellUuid, {
                  currency:
                    item[`Cell${col}EditStyle`] === "Currency" ||
                    item[`Cell${col}EditStyle`] === "currency"
                      ? "1"
                      : "0",
                  type: "ReportTableCell",
                  actions: item[`Cell${col}Action`] ?? "",
                  action_id: item[`Cell${col}ActionId`] ?? "",
                  value: item[`Cell${col}Data`] ?? "",
                  default_value: item[`Cell${col}Data`] ?? "",
                  hide: item[`Cell${col}Hide`] ?? "false",
                  errorMessage: item[`Cell${col}Error`] ?? "",
                });
              }
            }

            if (componentType === "CardSection" && item.Value1 !== undefined) {
              for (let valueIndex = 1; valueIndex <= 4; valueIndex++) {
                const valueUuid = item[`Value${valueIndex}uuid`];
                if (!valueUuid) continue;
                registerDerivedFieldUuid(valueUuid, {
                  currency: "1",
                  value: item[`Value${valueIndex}`] ?? "",
                  hide: item[`Value${valueIndex}Hide`] ?? "false",
                  errorMessage: item[`Value${valueIndex}Error`] ?? "",
                });
              }
            }
          });
        }

        if (componentType === "ResultCard") {
          Object.values(props).forEach((nested) => {
            if (nested && typeof nested === "object" && nested.uuid) {
              registerProps(nested, {
                value: nested.value ?? "",
                default_value: nested.default_value ?? "",
                hide: nested.hide ?? "false",
                errorMessage: nested.errorMessage ?? "",
              });
            }
          });
        }

        Object.values(props).forEach((value) => {
          if (value && typeof value === "object" && !Array.isArray(value) && value.uuid) {
            registerProps(value, {
              value: value.value ?? "",
              default_value: value.default_value ?? "",
              hide: value.hide ?? "false",
              errorMessage: value.errorMessage ?? "",
            });
          }
        });
      };

      const walk = (node) => {
        if (!node) return;
        if (Array.isArray(node)) {
          node.forEach(walk);
          return;
        }
        if (typeof node !== "object") return;

        if (node.props?.uuid) {
          const componentMeta = {
            type: node.type ?? "",
            value: node.props.value ?? "",
            default_value: node.props.default_value ?? "",
            hide: node.props.hide ?? "false",
            errorMessage:
              FIELDS_WITH_CONFIGURED_ERRORS.has(node.type)
                ? ""
                : (node.props.errorMessage ?? ""),
            required: node.props.required ?? false,
          };

          if (
            FIELDS_WITH_CONFIGURED_ERRORS.has(node.type) &&
            (node.props.errorMessage || node.props.customErrorMessage)
          ) {
            componentMeta.customErrorMessage =
              node.props.customErrorMessage || node.props.errorMessage;
          }

          registerProps(node.props, componentMeta);
        }

        if (node.props) {
          registerNestedFieldUuids(node.props, node.type ?? "");
        }

        Object.values(node).forEach(walk);
      };

      walk(structure.content);
      walk(structure.zones);
    });
  };

  const resolveActionPropsFromPage = (pageId, uuid) => {
    if (!pageId || !uuid) return null;
    const structure = parsePageStructure(roipages.current[pageId]);
    if (!structure) return null;

    let found = null;
    const walk = (node) => {
      if (!node || found) return;
      if (Array.isArray(node)) {
        node.forEach(walk);
        return;
      }
      if (typeof node !== "object") return;

      if (node.props?.uuid === uuid) {
        found = node.props;
        return;
      }
      if (node.uuid === uuid) {
        found = node;
        return;
      }

      Object.values(node).forEach(walk);
    };

    walk(structure.content);
    walk(structure.zones);
    return found;
  };

  const normalizePageStructureString = (structure) => {
    if (!structure || structure === "undefined") {
      return null;
    }
    if (typeof structure === "string") {
      return structure;
    }
    if (typeof structure === "object") {
      try {
        return JSON.stringify(structure);
      } catch (error) {
        console.error("[ROI] Failed to stringify page structure:", error);
        return null;
      }
    }
    return null;
  };

  const parsePageStructure = (structure) => {
    const structureString = normalizePageStructureString(structure);
    if (!structureString) {
      return null;
    }
    try {
      return JSON.parse(structureString);
    } catch (error) {
      console.error("[ROI] Failed to parse page structure:", error, structureString?.slice?.(0, 120));
      return null;
    }
  };

  const syncValidationDefaultMessagesFromPages = (pages) => {
    const next = { ...LEGACY_VALIDATION_DEFAULTS };

    Object.keys(pages || {}).forEach((pageId) => {
      const structure = parsePageStructure(pages[pageId]);
      if (!structure) return;

      const walk = (node) => {
        if (!node || typeof node !== "object") return;
        if (Array.isArray(node)) {
          node.forEach(walk);
          return;
        }

        if (node.type === "SinglePage" || node.type === "WizardForm") {
          const props = node.props || {};
          if (props.defaultRequiredFieldErrorMessage) {
            next.requiredField = props.defaultRequiredFieldErrorMessage;
          }
          if (props.defaultCheckboxErrorMessage) {
            next.checkbox = props.defaultCheckboxErrorMessage;
          }
          if (props.defaultRadioErrorMessage) {
            next.radio = props.defaultRadioErrorMessage;
          }
        }

        Object.values(node).forEach(walk);
      };

      walk(structure.content);
      walk(structure.zones);
    });

    validationDefaultMessages.current = next;
  };

  const resolveLogoPromptModalTextFromPage = (pageId) => {
    if (!pageId) {
      return { ...DEFAULT_LOGO_PROMPT_MODAL_TEXT };
    }

    const structure = parsePageStructure(roipages.current[pageId]);
    if (!structure) {
      return { ...DEFAULT_LOGO_PROMPT_MODAL_TEXT };
    }

    let headerProps = null;
    const walk = (node) => {
      if (!node || typeof node !== "object" || headerProps) return;
      if (Array.isArray(node)) {
        node.forEach(walk);
        return;
      }

      if (node.type === "PageHeader" || node.type === "ResultsPageHeader") {
        headerProps = node.props || {};
        return;
      }

      Object.values(node).forEach(walk);
    };

    walk(structure.content);
    if (!headerProps) {
      walk(structure.zones);
    }

    if (!headerProps) {
      return { ...DEFAULT_LOGO_PROMPT_MODAL_TEXT };
    }

    return {
      heading:
        headerProps.logoPromptHeading || DEFAULT_LOGO_PROMPT_MODAL_TEXT.heading,
      subheading:
        headerProps.logoPromptSubheading ||
        DEFAULT_LOGO_PROMPT_MODAL_TEXT.subheading,
      closeButtonText:
        headerProps.logoPromptCloseButtonText ||
        DEFAULT_LOGO_PROMPT_MODAL_TEXT.closeButtonText,
      confirmButtonText:
        headerProps.logoPromptConfirmButtonText ||
        DEFAULT_LOGO_PROMPT_MODAL_TEXT.confirmButtonText,
    };
  };

  const syncLogoPromptModalTextFromPage = (pageId) => {
    setLogoPromptModalText(resolveLogoPromptModalTextFromPage(pageId));
  };

  const getValidationDefaultMessage = (type) =>
    validationDefaultMessages.current[type] || LEGACY_VALIDATION_DEFAULTS[type];

  const isSystemDefaultValidationMessage = (message) => {
    if (!message) return false;
    return (
      Object.values(LEGACY_VALIDATION_DEFAULTS).includes(message) ||
      Object.values(validationDefaultMessages.current).includes(message)
    );
  };

  const clonePagesMap = (pages) => ({ ...pages });

  const setPageStructure = (pages, pageId, pageData) => {
    if (!pageData) {
      return pages;
    }
    const serialized =
      typeof pageData === "string" ? pageData : JSON.stringify(pageData);
    if (!serialized || serialized === "undefined") {
      console.warn("[ROI] Skipping invalid page serialization for:", pageId);
      return pages;
    }
    return { ...pages, [pageId]: serialized };
  };

  const updateByUuidSmart = (data, uuid, updates) => {
    // console.log("data", data, "uuid", uuid, "updates", updates);
    
    // Guard: Skip updates if UUID is empty or undefined to prevent mass updates
    if (!uuid || uuid === '' || uuid === undefined || uuid === null) {
      return data;
    }
    
    if (Array.isArray(data)) {
      return data.map((item) => updateByUuidSmart(item, uuid, updates));
    } else if (data && typeof data === "object") {
      // Handle component props.uuid
      if (data?.props?.uuid === uuid) {
        return {
          ...data,
          props: {
            ...data.props,
            ...updates,
          },
        };
      } 
      // Handle item.uuid (checkbox/radio options)
      else if (data.uuid === uuid) {
        return {
          ...data,
          ...updates,
        };
      }
      // Handle ReportTable/DownloadReportTable cell UUIDs (Cell1uuid, Cell2uuid, etc.)
      else if (data.Cell1uuid === uuid || data.Cell2uuid === uuid || data.Cell3uuid === uuid || data.Cell4uuid === uuid) {
        const newObj = { ...data };
        // Find which cell matches and update its data
        for (let i = 1; i <= 4; i++) {
          if (data[`Cell${i}uuid`] === uuid && updates.value !== undefined) {
            newObj[`Cell${i}Data`] = updates.value;
            break;
          }
        }
        return newObj;
      }

      const newObj = {};
      for (const key in data) {
        newObj[key] = updateByUuidSmart(data[key], uuid, updates);
      }
      return newObj;
    }
    return data;
  }

  function applyUpdatesToAllPages(pages, updateArray) {
    let updatedPages = { ...pages };
    // console.log("pages", pages, "updateArray", updateArray);
    for (const uuid of Object.keys(updateArray)) {
      const updates = updateArray[uuid];
      // console.log("updates", updates);
      for (const pageId in updatedPages) {
        // console.log("pageId", pageId);
        const pageDataString = normalizePageStructureString(updatedPages[pageId]);
        if (!pageDataString) {
          console.warn('Invalid page data in applyUpdatesToAllPages:', pageId, 'Data:', updatedPages[pageId]);
          continue;
        }
        
        const pageData = parsePageStructure(pageDataString);
        if (!pageData) {
          continue;
        }
        
        const updatedPage = updateByUuidSmart(pageData, uuid, updates);

        if (updatedPage !== pageData) {
          updatedPages = setPageStructure(updatedPages, pageId, updatedPage);
        }
      }
    }

    return updatedPages;
  }

  const stripCheckboxConfiguredErrors = (node) => {
    if (Array.isArray(node)) {
      return node.map(stripCheckboxConfiguredErrors);
    }
    if (!node || typeof node !== "object") {
      return node;
    }

    let nextNode = node;
    if (
      FIELDS_WITH_CONFIGURED_ERRORS.has(node.type) &&
      !node.props?.validationError &&
      (node.props?.errorMessage || node.props?.customErrorMessage)
    ) {
      const configuredMessage =
        node.props.customErrorMessage || node.props.errorMessage;
      nextNode = {
        ...node,
        props: {
          ...node.props,
          customErrorMessage: configuredMessage,
          errorMessage: "",
          validationError: false,
        },
      };
    }

    const result = { ...nextNode };
    Object.keys(result).forEach((key) => {
      const value = result[key];
      if (value && typeof value === "object") {
        result[key] = stripCheckboxConfiguredErrors(value);
      }
    });
    return result;
  };

  const normalizeCheckboxPagesInMap = (pages) => {
    const normalizedPages = { ...pages };

    Object.keys(normalizedPages).forEach((pageId) => {
      const parsedPage = parsePageStructure(normalizedPages[pageId]);
      if (!parsedPage) {
        return;
      }

      normalizedPages[pageId] = JSON.stringify(
        stripCheckboxConfiguredErrors(parsedPage)
      );
    });

    return normalizedPages;
  };

  const initialRender = (pageId = currentPageId.current) => {
    if (pageId !== '' && pageId !== undefined && pageId !== null) {
      syncLogoPromptModalTextFromPage(pageId);
      const parsedPage = parsePageStructure(roipages.current[pageId]);
      if (parsedPage) {
        setRenderData(stripCheckboxConfiguredErrors(parsedPage));
      } else {
        console.warn("[ROI] Invalid page data in initialRender:", pageId, {
          data: roipages.current[pageId],
          availablePageIds: Object.keys(roipages.current),
        });
      }
    }
  }

  // Function to render changes and trigger page updates
  // IMPORTANT: This function handles page re-rendering by preserving error states
  // to prevent loss of conditional error messages during React re-renders
  // 
  // Enhanced Features:
  // 1. Error message syncing from roiActionArr_global for consistency
  // 2. Bidirectional synchronization between global and local error states
  // 3. Priority-based error message resolution to prevent conflicts
  // 4. Preservation of existing error states during re-renders
  const renderChanges = (updates = {}, error_messages = {}, process_arr = {}, targetPageId = null) => {
    // console.log("updates", updates, "logicUpdates", error_messages, "process_arr", process_arr);
    
    const enhancedErrorMessages = { ...error_messages };

    // Honor explicit clears before syncing/preserving prior errors
    Object.keys(enhancedErrorMessages).forEach((uuid) => {
      if (enhancedErrorMessages[uuid]?.validationError === false) {
        clearFieldValidationState(uuid);
      }
    });
    
    // Sync error messages from roiActionArr_global to ensure consistency
    Object.keys(roiActionArr_global.current).forEach(uuid => {
      if (enhancedErrorMessages[uuid]?.validationError === false) {
        return;
      }

      const globalError = roiActionArr_global.current[uuid]?.errorMessage;
      const localError = enhancedErrorMessages[uuid]?.errorMessage;
      
      // If global state has an error message but local doesn't, sync it
      if (globalError && !localError) {
        enhancedErrorMessages[uuid] = {
          ...enhancedErrorMessages[uuid],
          uuid: uuid,
          errorMessage: globalError,
          validationError:
            roiActionArr_global.current[uuid]?.validationError === true ||
            enhancedErrorMessages[uuid]?.validationError === true ||
            Boolean(globalError),
        };
      }
      // If local has an error message but global doesn't, sync global state
      else if (localError && !globalError) {
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: localError,
          validationError:
            enhancedErrorMessages[uuid]?.validationError === true ||
            roiActionArr_global.current[uuid]?.validationError === true,
        };
      }
      // If both have different error messages, prioritize the most recent one
      else if (globalError && localError && globalError !== localError) {
        const priorityError = isSystemDefaultValidationMessage(globalError)
          ? localError
          : globalError;
        enhancedErrorMessages[uuid] = {
          ...enhancedErrorMessages[uuid],
          uuid: uuid,
          errorMessage: priorityError,
          validationError:
            enhancedErrorMessages[uuid]?.validationError === true ||
            roiActionArr_global.current[uuid]?.validationError === true,
        };
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: priorityError,
          validationError: true,
        };
      }
    });
    
    // Preserve existing error states from global state before merging updates
    const preservedErrorStates = {};
    Object.keys(roiActionArr_global.current).forEach(uuid => {
      if (enhancedErrorMessages[uuid]?.validationError === false) {
        return;
      }

      if (
        roiActionArr_global.current[uuid]?.errorMessage &&
        roiActionArr_global.current[uuid]?.validationError
      ) {
        preservedErrorStates[uuid] = {
          uuid: uuid,
          errorMessage: roiActionArr_global.current[uuid].errorMessage,
          validationError: true,
        };
      }
    });
    
    // Explicit error updates must win over preserved state
    const mergedUpdates = mergeUpdatesByUUID(
      updates,
      process_arr,
      preservedErrorStates,
      enhancedErrorMessages
    );
    // console.log("mergedUpdates", mergedUpdates);
    const updatedPages = applyUpdatesToAllPages(roipages.current, mergedUpdates);
    roipages.current = updatedPages;
    const pageIdToRender = targetPageId || currentPageId.current;
    syncLogoPromptModalTextFromPage(pageIdToRender);
    const parsedPage = parsePageStructure(updatedPages[pageIdToRender]);
    if (parsedPage) {
      setRenderData(stripCheckboxConfiguredErrors(parsedPage));
    } else {
      console.warn("[ROI] Invalid page data for render:", pageIdToRender, {
        rawData: updatedPages[pageIdToRender],
        currentPageId: currentPageId.current,
        availablePageIds: Object.keys(updatedPages),
        roiId,
        apiUrl,
      });
    }
  };

  function mergeUpdatesByUUID(...updateObjects) {
    const merged = {};

    for (const updateObj of updateObjects) {
      for (const uuid in updateObj) {
        if (!merged[uuid]) merged[uuid] = {};
        merged[uuid] = {
          ...merged[uuid],
          ...updateObj[uuid], // merge inner keys like value, errorMessage, etc.
        };
      }
    }

    return merged;
  }

  useEffect(() => {

    if (
      currentPopupPageId !== "" &&
      roipages.current[currentPopupPageId] !== undefined &&
      popupStatus == true
    ) {
      setRenderModalData(JSON.parse(roipages.current[currentPopupPageId]));
    }

  }, [roipages.current, currentPageId, currentPopupPageId]);

  // Restore focus after rerendering to maintain tab index functionality
  useEffect(() => {
    if (focusedInputId && renderData) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        const element = document.getElementById(focusedInputId);
        if (element) {
          element.focus();
        }
      }, 50);
    }
  }, [renderData, focusedInputId]);

  // Prevent wheel scroll on number inputs
  useEffect(() => {
    const handleWheelOnNumberInputs = (e) => {
      if (e.target.type === 'number') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };

    // Add multiple event listeners to catch all wheel events
    document.addEventListener('wheel', handleWheelOnNumberInputs, { passive: false, capture: true });
    document.addEventListener('mousewheel', handleWheelOnNumberInputs, { passive: false, capture: true });
    document.addEventListener('DOMMouseScroll', handleWheelOnNumberInputs, { passive: false, capture: true });

    return () => {
      document.removeEventListener('wheel', handleWheelOnNumberInputs, { capture: true });
      document.removeEventListener('mousewheel', handleWheelOnNumberInputs, { capture: true });
      document.removeEventListener('DOMMouseScroll', handleWheelOnNumberInputs, { capture: true });
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      resetCalculatorState();
      setIsLoading(true);
      setRenderData(null);

      try {
        const response = await fetch(`${apiUrl}/roi/getRoiDetail/${roiId}`);
        const data = await response.json();
        const res = data.data;

        if (roiId === '8f6f1310-37cd-11f0-abf5-597b40e01b7c') {
          document.title = 'Microsoft 365 Mixed Licence Calculator';
        } else if (res.roi_name) {
          document.title = res.roi_name;
        }

        setAcceptDecimals(res.accept_decimals);
        setIsIdPresent(res.is_active);
        setLanguage(res.default_language);
        setDefaultCurrency(JSON.parse(res.primary_currency)[0]);

        // setChangedCurrency(JSON.parse(res.primary_currency)[0])
        setCurrency(JSON.parse(res.additional_currency));
        // getting first strucuture api call

        const response1 = await fetch(`${apiUrl}/roi-currency/list`);
        const result1 = await response1.json();
        const res1 = result1.data;

        Object.keys(res1).map((key) => {
          if (res1[key].currency_name == JSON.parse(res.primary_currency)[0]) {
            setCurrencySymbol(res1[key].symbol);
            setLocale("en-US");
            setExchangeRate(res1[key].exchange_rate);
          }
        });

        try {
          const responseStructure = await fetch(
            `${apiUrl}/roi-pages/detail/${roiId}`
          );
          const dataStructure = await responseStructure.json();

          // Full API response including every page structure (for debugging)
          console.log("[ROI] Pages API full response", dataStructure);
          console.log(
            "[ROI] Pages API URL",
            `${apiUrl}/roi-pages/detail/${roiId}`,
            "status:",
            responseStructure.status,
            "database:",
            dataStructure?.database
          );
          (dataStructure?.result || []).forEach((page, index) => {
            let parsedStructure = null;
            try {
              parsedStructure = page.structure ? JSON.parse(page.structure) : null;
            } catch (parseError) {
              console.error(
                "[ROI] Failed to parse structure for page",
                page.page_name,
                page.roi_page_id,
                parseError
              );
            }
            console.log(`[ROI] Page ${index + 1} structure`, {
              roi_page_id: page.roi_page_id,
              page_name: page.page_name,
              page_no: page.page_no,
              roi_id: page.roi_id,
              structureLength: page.structure?.length ?? 0,
              structureRaw: page.structure,
              structureParsed: parsedStructure,
            });
          });

          console.log("[ROI] Pages API summary", {
            url: `${apiUrl}/roi-pages/detail/${roiId}`,
            status: responseStructure.status,
            database: dataStructure?.database,
            resultCount: dataStructure?.result?.length ?? 0,
            pageIds: (dataStructure?.result || []).map((page) => page.roi_page_id),
            pageNames: (dataStructure?.result || []).map((page) => ({
              id: page.roi_page_id,
              name: page.page_name,
              hasStructure: !!page.structure,
            })),
          });
          // setCurrentPageId(dataStructure.result?.[0]?.roi_page_id);
          currentPageId.current = dataStructure.result?.[0]?.roi_page_id;

          const parsedRenderData = JSON.parse(
            dataStructure.result?.[0]?.structure
          );
          let roi_content = {};
          let roi_global_arr = {};
          let data = dataStructure.result;
          for (let i = 0; i < data.length; i++) {
            const pageStructure = normalizePageStructureString(data[i].structure);
            if (!pageStructure) {
              console.warn("[ROI] Page missing structure in API response:", {
                roi_page_id: data[i].roi_page_id,
                page_name: data[i].page_name,
              });
              continue;
            }
            roi_content[data[i].roi_page_id] = pageStructure;
            let data__ = JSON.parse(pageStructure)["content"];
            Object.keys(data__).forEach((element, index) => {
              if (
                data__[element]?.type == "InputTextField" ||
                data__[element]?.type == "InputNumberField" ||
                data__[element]?.type == "Button" ||
                data__[element]?.type == "Wrapper "
              ) {
                Object.keys(data__[element]?.props).forEach(
                  (element2, index2) => {
                    if (data__[element]?.props?.uuid != undefined) {
                      roi_global_arr[data__[element]?.props?.uuid] = {};
                      roi_global_arr[data__[element]?.props?.uuid]["count"] = 0;
                      roi_global_arr[data__[element]?.props?.uuid]["actions"] = data__[element]?.props?.buttonAction ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["action_id"] = getButtonPageId(data__[element]?.props);
                      roi_global_arr[data__[element]?.props?.uuid]["link"] = data__[element]?.props?.buttonLink ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["value"] = data__[element]?.props?.value ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["default_value"] = data__[element]?.props?.default_value ?? "";
                      roi_global_arr[data__[element]?.props?.uuid]["hide"] = data__[element]?.props?.hide ?? "false";
                      if (
                        data__[element]?.type === "InputTextField" ||
                        data__[element]?.type === "InputNumberField"
                      ) {
                        roi_global_arr[data__[element]?.props?.uuid]["customErrorMessage"] =
                          data__[element]?.props?.errorMessage ?? "";
                        roi_global_arr[data__[element]?.props?.uuid]["errorMessage"] = "";
                      } else {
                        roi_global_arr[data__[element]?.props?.uuid]["errorMessage"] =
                          data__[element]?.props?.errorMessage ?? "";
                      }
                      roi_global_arr[data__[element]?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;
                    }
                  }
                );
              } else {
                Object.keys(data__[element]?.props).forEach(
                  (element2, index2) => {
                    if (data__[element]?.props[element2].uuid != undefined) {
                      if (
                        element2 !== "image" &&
                        element2 !== "logo" &&
                        element2 !== "items" &&
                        element2 !== "id" &&
                        element2 !== "Padding" &&
                        element2 !== "Style"
                      ) {
                        roi_global_arr[data__[element]?.props[element2].uuid] = {};
                        roi_global_arr[data__[element]?.props[element2].uuid]["count"] = 0;
                        roi_global_arr[data__[element]?.props[element2].uuid]["actions"] = data__[element]?.props[element2].buttonAction ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["action_id"] = getButtonPageId(data__[element]?.props[element2]);
                        roi_global_arr[data__[element]?.props[element2].uuid]["link"] = data__[element]?.props[element2].buttonLink ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["value"] = data__[element]?.props?.[element2]?.value ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["default_value"] = data__[element]?.props[element2].default_value ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["hide"] = data__[element]?.props[element2].hide ?? "false";
                        roi_global_arr[data__[element]?.props[element2].uuid]["errorMessage"] = data__[element]?.props[element2].errorMessage ?? "";
                        roi_global_arr[data__[element]?.props[element2].uuid]["roi_page_id"] = data[i].roi_page_id;
                      }
                    }
                  }
                );
              }
            });

            let data_zones__ = JSON.parse(pageStructure)["zones"];
            Object.keys(data_zones__).forEach((element, index) => {
              Object.keys(data_zones__[element]).forEach(
                (element__, index__) => {
                  let data_element__ = data_zones__[element][element__];
                  if (data_element__?.props.uuid != undefined) {
                    if (
                      data_element__?.type === "InputTextField" ||
                      data_element__?.type === "InputNumberField" ||
                      data_element__?.type === "Dropdown" ||
                      data_element__?.type === "Button" ||
                      data_element__?.type === "Wrapper"
                    ) {
                      roi_global_arr[data_element__?.props.uuid] = {};
                      roi_global_arr[data_element__?.props.uuid]["currency"] = data_element__?.props.prefix == "currency" || data_element__?.props.prefix == "Currency" || data_element__?.props.Prefix == "Currency" || data_element__?.props.Prefix == "currency" ? "1" : "0";
                      roi_global_arr[data_element__?.props.uuid]["count"] = 0;
                      roi_global_arr[data_element__?.props.uuid]["required"] = data_element__?.props.required ?? false;
                      roi_global_arr[data_element__?.props.uuid]["type"] = data_element__?.type ?? "";
                      roi_global_arr[data_element__?.props.uuid]["actions"] = data_element__?.props.buttonAction ?? "";
                      roi_global_arr[data_element__?.props.uuid]["action_id"] = getButtonPageId(data_element__?.props);
                      roi_global_arr[data_element__?.props.uuid]["link"] = data_element__?.props.buttonLink ?? "";
                      roi_global_arr[data_element__?.props.uuid]["value"] = data_element__?.props?.value ?? "";
                      roi_global_arr[data_element__?.props.uuid]["default_value"] = data_element__?.props.default_value ?? "";
                      roi_global_arr[data_element__?.props.uuid]["roi_page_id"] = data[i].roi_page_id;
                      roi_global_arr[data_element__?.props.uuid]["hide"] = data_element__?.props.hide ?? "false";
                      if (
                        data_element__?.type === "InputTextField" ||
                        data_element__?.type === "InputNumberField"
                      ) {
                        roi_global_arr[data_element__?.props.uuid]["customErrorMessage"] =
                          data_element__?.props?.errorMessage ?? "";
                        roi_global_arr[data_element__?.props.uuid]["errorMessage"] = "";
                      } else {
                        roi_global_arr[data_element__?.props.uuid]["errorMessage"] =
                          data_element__?.props.errorMessage ?? "";
                      }
                    }

                    if (data_element__?.type === "Checkbox") {
                      roi_global_arr[data_element__?.props?.uuid] = {};
                      roi_global_arr[data_element__?.props?.uuid]["count"] = 0;
                      roi_global_arr[data_element__?.props?.uuid]["required"] = data_element__?.props?.required ?? false;
                      roi_global_arr[data_element__?.props?.uuid]["type"] = "Checkbox";
                      roi_global_arr[data_element__?.props?.uuid]["actions"] = data_element__?.props?.buttonAction ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["action_id"] = getButtonPageId(data_element__?.props);
                      roi_global_arr[data_element__?.props?.uuid]["link"] = data_element__?.props?.buttonLink ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["value"] = data_element__?.props?.value ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["default_value"] = data_element__?.props?.default_value ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["hide"] = data_element__?.props?.hide ?? "false";
                      roi_global_arr[data_element__?.props?.uuid]["customErrorMessage"] = data_element__?.props?.errorMessage ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["errorMessage"] = "";
                      roi_global_arr[data_element__?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;

                      Object.keys(data_element__?.props?.items).forEach(
                        (element, index) => {
                          // Generate UUID if missing for checkbox item
                          let itemUuid = data_element__?.props?.items[element]?.uuid;
                          if (!itemUuid || itemUuid === '' || itemUuid === undefined) {
                            itemUuid = uuidv4();
                            // Update the item with the new UUID
                            if (data_element__?.props?.items[element]) {
                              data_element__.props.items[element].uuid = itemUuid;
                            }
                          }
                          
                          if (itemUuid) {
                            roi_global_arr[itemUuid] = {};
                            roi_global_arr[itemUuid]["currency"] =
                              data_element__?.props?.items[element]?.prefix ==
                                "currency" ||
                                data_element__?.props?.items[element]?.prefix ==
                                "Currency" ||
                                data_element__?.props?.items[element]?.Prefix ==
                                "currency" ||
                                data_element__?.props?.items[element]?.Prefix ==
                                "Currency"
                                ? "1"
                                : "0";
                            roi_global_arr[itemUuid]["count"] = 0;
                            roi_global_arr[itemUuid]["required"] = data_element__?.props?.required ?? false;
                            roi_global_arr[itemUuid]["type"] = "Checkbox Option";
                            roi_global_arr[itemUuid]["actions"] = data_element__?.props?.items[element]?.buttonAction ?? "";
                            roi_global_arr[itemUuid]["action_id"] = getButtonPageId(data_element__?.props?.items[element]);
                            roi_global_arr[itemUuid]["link"] = data_element__?.props?.items[element]?.buttonLink ?? "";
                            roi_global_arr[itemUuid]["value"] = data_element__?.props?.items[element]?.value ?? "";
                            roi_global_arr[itemUuid]["default_value"] = data_element__?.props?.items[element]?.default_value ?? "";
                            roi_global_arr[itemUuid]["hide"] = data_element__?.props?.items[element]?.hide ?? "false";
                            roi_global_arr[itemUuid]["errorMessage"] = data_element__?.props?.items[element]?.errorMessage ?? "";
                            roi_global_arr[itemUuid]["roi_page_id"] = data[i].roi_page_id;
                            roi_global_arr[itemUuid]["checkbox_id"] = data_element__?.props?.uuid;
                          }
                        }
                      );
                    }

                    if (data_element__?.type === "Radio") {
                      // Object.keys(data_element__?.props?.items).forEach(
                      //(element, index) => {
                      if (data_element__?.props?.uuid != undefined) {
                        roi_global_arr[data_element__?.props?.uuid] = {};
                        roi_global_arr[data_element__?.props?.uuid]["currency"] =
                          data_element__?.props?.prefix ==
                            "currency" ||
                            data_element__?.props?.prefix ==
                            "Currency" ||
                            data_element__?.props?.Prefix ==
                            "currency" ||
                            data_element__?.props?.Prefix ==
                            "Currency"
                            ? "1"
                            : "0";
                        roi_global_arr[data_element__?.props?.uuid]["count"] = 0;
                        roi_global_arr[data_element__?.props?.uuid]["required"] = data_element__?.props?.required ?? false;
                        roi_global_arr[data_element__?.props?.uuid]["actions"] = data_element__?.props?.buttonAction ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["action_id"] = getButtonPageId(data_element__?.props);
                        roi_global_arr[data_element__?.props?.uuid]["link"] = data_element__?.props?.buttonLink ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["value"] = "0";
                        roi_global_arr[data_element__?.props?.uuid]["default_value"] = data_element__?.props?.default_value ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["type"] = "Radio";
                        roi_global_arr[data_element__?.props?.uuid]["hide"] = data_element__?.props?.hide ?? "false";
                        roi_global_arr[data_element__?.props?.uuid]["customErrorMessage"] =
                          data_element__?.props?.errorMessage ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["errorMessage"] = "";
                        roi_global_arr[data_element__?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;
                      }
                      //}
                      //);
                    }
                  }
                  if (
                    data_element__?.props?.uuid == undefined &&
                    data_element__?.props?.items != undefined
                  ) {
                    Object.keys(data_element__?.props?.items).forEach(
                      (element, index) => {
                        if (
                          data_element__?.props?.items[element]?.uuid !=
                          undefined
                        ) {
                          //this will also work in case of button in card section

                          roi_global_arr[data_element__?.props?.items[element]?.uuid] = {};
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["currency"] = data_element__?.props?.items[element]?.prefix == "currency" || data_element__?.props?.items[element]?.prefix == "Currency" ? "1" : "0";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["count"] = 0;
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["actions"] = data_element__?.props?.items[element]?.buttonAction ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["action_id"] = getButtonPageId(data_element__?.props?.items[element]);
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["link"] = data_element__?.props?.items[element]?.buttonLink ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["value"] = data_element__?.props?.items[element]?.value ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["default_value"] = data_element__?.props?.items[element]?.default_value ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["hide"] = data_element__?.props?.items[element]?.hide ?? "false";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["errorMessage"] = data_element__?.props?.items[element]?.errorMessage ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                        }

                        if (
                          data_element__?.props?.items[element]?.uuid ==
                          undefined &&
                          (data_element__?.type === "DownloadReportTable" ||
                            data_element__?.type === "ReportTable")
                        ) {
                          Object.keys(
                            data_element__?.props?.items[element]
                          ).forEach((element_, index_) => {
                            let cols_count =
                              data_element__?.props?.Table.Columns;
                            // Use 'col' instead of 'i' to avoid variable shadowing with outer page loop
                            for (let col = 1; col <= cols_count; col++) {
                              if (
                                data_element__?.props?.items[element]?.["Cell" + col + "uuid"] != undefined
                              ) {
                                const cellUuid = data_element__?.props?.items[element]?.["Cell" + col + "uuid"];
                                roi_global_arr[cellUuid] = {};
                                roi_global_arr[cellUuid]["currency"] = data_element__?.props?.items[element]?.["Cell" + col + "EditStyle"] == "Currency" || data_element__?.props?.items[element]?.["Cell" + col + "EditStyle"] == "currency" ? "1" : "0";
                                roi_global_arr[cellUuid]["count"] = 0;
                                roi_global_arr[cellUuid]["type"] = "ReportTableCell";
                                roi_global_arr[cellUuid]["actions"] = data_element__?.props?.items[element]?.["Cell" + col + "Action"] ?? "";
                                roi_global_arr[cellUuid]["action_id"] = data_element__?.props?.items[element]?.["Cell" + col + "ActionId"] ?? "";
                                roi_global_arr[cellUuid]["link"] = "";
                                roi_global_arr[cellUuid]["value"] = data_element__?.props?.items[element]?.["Cell" + col + "Data"] ?? "";
                                roi_global_arr[cellUuid]["default_value"] = data_element__?.props?.items[element]?.["Cell" + col + "Data"] ?? "";
                                roi_global_arr[cellUuid]["hide"] = data_element__?.props?.items[element]?.["Cell" + col + "Hide"] ?? "false";
                                roi_global_arr[cellUuid]["errorMessage"] = data_element__?.props?.items[element]?.["Cell" + col + "Error"] ?? "";
                                roi_global_arr[cellUuid]["roi_page_id"] = data[i].roi_page_id;  // Now correctly uses outer loop 'i'
                              }
                            }
                          });
                        }

                        if (
                          data_element__?.props?.items[element]?.Value1 !=
                          undefined &&
                          data_element__?.type === "CardSection"
                        ) {
                          Object.keys(
                            data_element__?.props?.items[element]
                          ).forEach((element_, index_) => {
                            for (let i = 1; i <= 4; i++) {
                              if (
                                data_element__?.props?.items[element]?.["Value" + i + "uuid"] != undefined
                              ) {
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]] = {};
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["currency"] = "1";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["count"] = 0;
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["actions"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["action_id"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["link"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["value"] = data_element__?.props?.items[element]?.["Value" + i] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["default_value"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["hide"] = data_element__?.props?.items[element]?.["Value" + i + "Hide"] ?? "false";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["errorMessage"] = data_element__?.props?.items[element]?.["Value" + i + "Error"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["roi_page_id"] = data[i].roi_page_id;
                              }
                            }
                          });
                        }
                      }
                    );
                  }

                  if (
                    data_element__?.props?.uuid == undefined &&
                    data_element__?.props?.items == undefined
                  ) {
                    if (data_element__?.type === "ResultCard") {
                      Object.keys(data_element__?.props).forEach(
                        (element, index) => {
                          if (
                            data_element__?.props?.[element]?.uuid != undefined
                          ) {
                            roi_global_arr[data_element__?.props?.[element]?.uuid] = {};
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["currency"] = "1";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["count"] = 0;
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["actions"] = data_element__?.props?.[element]?.buttonAction ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["action_id"] = getButtonPageId(data_element__?.props?.[element]);
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["link"] = data_element__?.props?.[element]?.buttonLink ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["value"] = data_element__?.props?.[element]?.value ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["default_value"] = data_element__?.props?.[element]?.default_value ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["hide"] = data_element__?.props?.[element]?.hide ?? "false";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["errorMessage"] = data_element__?.props?.[element]?.errorMessage ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                          }
                        }
                      );
                    }
                  }

                  if (data_element__?.type === "ChartCard" || data_element__?.type === "eCharts") {
                    let props = data_element__?.props;
                    Object.keys(props).forEach((element, index) => {
                      if (
                        props[element]?.uuid != undefined &&
                        (props[element]?.chooseChart == "pie" ||
                          props[element]?.chooseChart == "bar")
                      ) {
                        for (
                          let i = 0;
                          i < props[element]?.items?.length;
                          i++
                        ) {
                          roi_global_arr[props[element]?.items[i].uuid] = {};
                          roi_global_arr[props[element]?.items[i].uuid]["currency"] = "1";
                          roi_global_arr[props[element]?.items[i].uuid]["count"] = 0;
                          roi_global_arr[props[element]?.items[i].uuid]["actions"] = props[element]?.items[i].buttonAction ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["action_id"] = getButtonPageId(props[element]?.items[i]);
                          roi_global_arr[props[element]?.items[i].uuid]["link"] = props[element]?.items[i].buttonLink ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["value"] = props[element]?.items[i].value ?? props[element]?.items[i].Data ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["default_value"] = props[element]?.items[i].default_value ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["hide"] = props[element]?.items[i].hide ?? "false";
                          roi_global_arr[props[element]?.items[i].uuid]["errorMessage"] = props[element]?.items[i].errorMessage ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["roi_page_id"] = data[i].roi_page_id;
                        }
                      }
                    });
                  }
                }
              );
            });
          }
          // console.log("=== DEBUG: roi_content (pages) ===");
          // console.log("Available page IDs:", Object.keys(roi_content));
          // console.log("Looking for page 5264b830-8237-11f0-ae7e-ed4b67a3e229:", roi_content["5264b830-8237-11f0-ae7e-ed4b67a3e229"]);
          // Build element map from DB page structures (source of truth)
          resyncActionEntriesFromPages(data, roi_global_arr);
          dedupeFlatRoiGlobalKeys(roi_global_arr);

          roipages.current = normalizeCheckboxPagesInMap(roi_content);
          syncValidationDefaultMessagesFromPages(roipages.current);
          console.log("[ROI] Loaded page map", {
            pageCount: Object.keys(roi_content).length,
            pageIds: Object.keys(roi_content),
          });

          const responseCustomVariables = await fetch(
            `${apiUrl}/roi-custom-variables/list/${roiId}`
          );
          const dataCustomVariables = await responseCustomVariables.json();
          if (dataCustomVariables.result == "success") {
            let customVariablesArray = dataCustomVariables.data;
            for (let i = 0; i < customVariablesArray.length; i++) {
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id] =
                {};
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["currency"] = customVariablesArray[i].roi_custom_variable_type == "currency" ? "1" : "0";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["count"] = 0;
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["actions"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["action_id"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["link"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["value"] = customVariablesArray[i].roi_custom_variable_value;
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["default_value"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["hide"] = "false";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["errorMessage"] = "";
            }
          }

          // setRoiActionArr(roi_global_arr);
          // console.log("=== DEBUG: roi_global_arr before setting to roiActionArr_global ===");
          // console.log("Looking for UUID 5264b830-8237-11f0-ae7e-ed4b67a3e229:", roi_global_arr["5264b830-8237-11f0-ae7e-ed4b67a3e229"]);
          // console.log("All UUIDs in roi_global_arr:", Object.keys(roi_global_arr));
          roiActionArr_global.current = roi_global_arr;


          Object.keys(roi_global_arr).forEach((element) => {
            if (element.includes("::")) return;
            if (elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]] === undefined) {
              elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]] = [];
            }
            elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]].push(element);
          });

          initialRender();
          setRenderData(stripCheckboxConfiguredErrors(parsedRenderData));
        } catch (error) {
          console.error(error);
        }

        // getting all condtional logic api call
        try {
          const conditionalLogics_response = await fetch(
            `${apiUrl}/roi-calculated-fields/list/${roiId}`
          );
          const json_conditionalLogics_response =
            await conditionalLogics_response.json();

          if (json_conditionalLogics_response.result == "success") {
            let data = json_conditionalLogics_response.data;

            const roiCalculationLogic = {};
            let count = 0;
            Object.keys(data).forEach((element, index) => {
              if (
                data[element].roi_calculation_logic != undefined &&
                data[element].roi_calculation_logic != null
              ) {
                const data__ = JSON.parse(data[element].roi_calculation_logic);

                if (data__["when"].length == 1) {
                  data__["when_and_or_operator"] = "";
                }

                if (
                  (data__["when"].length > 1 &&
                    data__["when_and_or_operator"] == undefined) ||
                  data__["when_and_or_operator"] == null
                ) {
                  data__["when_and_or_operator"] = "AND";
                }

                if (roiCalculationLogic[data[element].roi_calculated_field_id] === undefined) {
                  roiCalculationLogic[data[element].roi_calculated_field_id] = [];
                }

                data__["logic_name"] = data[element].roi_logic_name;

                roiCalculationLogic[data[element].roi_calculated_field_id].push(
                  data__
                );
                // count++;
                // }
              }
            });
            // setAllConditionalLogicData(roiCalculationLogic);
            allCondtionalLogicData.current = roiCalculationLogic;
          }
        } catch (error) {
          console.error(error);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [apiUrl, roiId]);

  // Debounce function with useCallback
  // const debouncedOnChange = useMemo(
  //   () => debounce(handleChange, 1000),
  //   [handleChange]
  // );


  if (isLoading) {
    return <div>Loading...</div>;
  }

  const renderDataBlock = () => {
    return (
      <>
        <Render config={config} data={renderData} />

        <div
          className="modal fade logo-prompt"
          id="logoPrompt"
          tabIndex={-1}
          aria-labelledby="logoPromptLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="heading">
                  <h3>{logoPromptModalText.heading}</h3>
                  <p>{logoPromptModalText.subheading}</p>
                </div>

                <div className="modal-buttons d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-bordered color-cancel"
                    data-bs-dismiss="modal"
                  >
                    {logoPromptModalText.closeButtonText}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ms-3"
                    onClick={homeRedirect}
                  >
                    {logoPromptModalText.confirmButtonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderModalDataBlock = () => {
    return <Render config={config} data={renderModalData} />;
  };

  // Helper function to parse HTML and replace dynamic spans
  const parseDynamicText = (htmlString) => {
    if (!htmlString || typeof htmlString !== 'string') {
      return htmlString;
    }

    try {
      // console.log('Parsing dynamic text:', htmlString);

    // Create a temporary DOM element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Function to recursively process nodes and replace dynamic spans
    // Note: Multiple spans can use the same UUID to show the same value
    // React keys are made unique by appending random values
    const processNode = (node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.tagName.toLowerCase() === 'span' && node.getAttribute('uuid')) {
          const uuid = node.getAttribute('uuid');
          const style = node.getAttribute('style') || '';
          const className = node.getAttribute('class') || '';

          // Debug: Print the entire roiActionArr_global.current object
          // console.log('=== DEBUG: roiActionArr_global.current ===');
          // console.log('Full object:', roiActionArr_global.current);
          // console.log('Current UUID being processed:', uuid);
          // console.log('Value for this UUID:', roiActionArr_global.current[uuid]);
          // console.log('Value property:', roiActionArr_global.current[uuid]?.value);
          // console.log('==========================================');
          
          // Parse styles safely
          const parsedStyles = parseInlineStyles(style);
          
          // Ensure we have a valid style object
          const finalStyles = parsedStyles && typeof parsedStyles === 'object' ? parsedStyles : {};
          
          // Create a dynamic span component
          // Generate unique key for React while keeping the same UUID for value lookup
          const uniqueKey = `${uuid}-${Math.random()}`;
          
          return (
            <span
              key={uniqueKey}
              style={finalStyles}
              className={`dynamic-inline-span ${className || ''}`}
            >
              {roiActionArr_global.current[uuid]?.value || '0'}
            </span>
          );
        } else {
          // Process child nodes recursively
          const children = Array.from(node.childNodes).map((child, childIndex) => 
            processNode(child)
          );
          
          // Create a new element with the same tag and attributes
          const attributes = Array.from(node.attributes).reduce((attrs, attr) => {
            if (attr.name !== 'uuid') { // Don't pass uuid attribute
              if (attr.name === 'style') {
                // Parse style attribute for all elements
                const parsedStyles = parseInlineStyles(attr.value);
                // console.log('Parsed styles for', node.tagName, ':', parsedStyles);
                if (parsedStyles && typeof parsedStyles === 'object') {
                  attrs.style = parsedStyles;
                }
              } else if (attr.name === 'class') {
                // Convert class to className for React
                attrs.className = attr.value;
              } else {
                attrs[attr.name] = attr.value;
              }
            }
            return attrs;
          }, {});
          
          // console.log('Creating element with attributes:', attributes);
          
          const newElement = React.createElement(
            node.tagName.toLowerCase(),
            {
              key: `node-${Math.random()}`, // Use unique key instead of undefined index
              ...attributes
            },
            ...children
          );
          
          return newElement;
        }
      } else if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }
      
      return null;
    };

    // Process all child nodes
    const processedChildren = Array.from(tempDiv.childNodes).map((child, index) => 
      processNode(child)
    );

    return processedChildren;
    } catch (error) {
      console.error('Error parsing dynamic text:', error);
      return htmlString; // Fallback to original text if parsing fails
    }
  };

  // Helper function to parse inline styles
  const parseInlineStyles = (styleString) => {
    if (!styleString || typeof styleString !== 'string') return {};
    
    try {
      // console.log('Parsing style string:', styleString);
      const styles = {};
      const stylePairs = styleString.split(';').filter(pair => pair.trim());
      
      stylePairs.forEach(pair => {
        const colonIndex = pair.indexOf(':');
        if (colonIndex > 0) {
          const property = pair.substring(0, colonIndex).trim();
          const value = pair.substring(colonIndex + 1).trim();
          
          if (property && value) {
            // Convert CSS property names to camelCase
            const camelProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
            // Only add valid CSS properties
            if (camelProperty && value) {
              styles[camelProperty] = value;
              // console.log('Added style:', camelProperty, '=', value);
            }
          }
        }
      });
      
      // console.log('Final parsed styles:', styles);
      return styles;
    } catch (error) {
      console.error('Error parsing inline styles:', error);
      return {}; // Return empty object on error
    }
  };

  return (
    <>
      <ToastContainer />
      {renderData !== null && allCondtionalLogicData.current !== null ? (
        renderDataBlock()
      ) : (
        <div>Loading...</div>
      )}

      <div
        className="modal fade modal-report"
        id="reportModal"
        tabIndex={-1}
        aria-labelledby="reportModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            {renderModalData !== null && allCondtionalLogicData.current !== null ? (
              renderModalDataBlock()
            ) : (
              <div>Loading...</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ROIPage;
